/* eslint-disable no-template-curly-in-string, max-len */
export default {
  notification: {
    successPaidTicketPayment: [
      'Successfully paid $${price} for ${type} ticket',
      '成功购买${type}门票, 总计$${price}'
    ],
    successFreeTicket: [
      'Successfully obtain free ticket',
      '成功获得免费门票'
    ],
    acceptJoinTeam: [
      'Host of team ${teamName} welcomes you to join',
      '${teamName}队长欢迎您加入'
    ],
    rejectJoinTeam: [
      'Host of team ${teamName} rejected you to join',
      '${teamName}队长拒绝您的申请'
    ],
    kickedByTeam: [
      'You have been removed from the team ${teamName}',
      '你被${teamName}团队踢出了'
    ],
    requestToJoinTeam: [
      'User ${userName} wants to join your team ${teamName}',
      '用户${userName}想加入你的团队${teamName}'
    ],
    applyToEvent: [
      'User ${userName} applied to join your event ${eventName}',
      '用户${userName}想加入你的活动${eventName}'
    ],
    joinEvent: [
      'User ${userName} just joined your event ${eventName}',
      '用户${userName}加入了你的活动${eventName}'
    ]
  },
  alert: {
    success: {
      scheduleDemo: ['Thank you so much.Your application has been received, we will contact you as soon as possible!',
        '非常感谢，您的申请已经发出，我们会尽快联系您！'],
      resetScores: [
        'Successfully reset all scores',
        '成功重置所有分数'
      ],
      xinshiSuccessSubmitProfile: [
        'Your application has been received, it may take a couple of days to process. We will notify you once it\'s completed.',
        '已收到您的申请，可能需要几天处理。一旦完成，我们会通知您。'
      ],
      uploadResumeSuccess: ['Upload Resume Successfully', '上传简历成功'],
      updatePassword: ['Successfully updated password', '成功更新密码'],
      sendRequestToMentor: [
        'We have sent your request to our mentors. Help is on the way :)',
        '导师已经收到了你的问题，马上过来'
      ],
      createTeam: ['Successfully created team', '成功创建团队'],
      updateTeam: ['Successfully updated team', '成功更新团队'],
      emailSentToParticipants: ['Invitation email has been sent to the selected participants.', '邀请函已发送'],
      sendInvitationEmail: ['Invitation emails have been successfully sent out.', '邀请函已成功发送'],
      createEvent: ['Successfully create an event.', '创建活动成功'],
      cloneEvent: ['Successfully clone an event.', '复制活动成功'],
      editEvent: ['Successfully edit your event.', '编辑活动成功'],
      deleteEvent: ['Successfully delete your event.', '删除活动成功'],
      createJudgingCriteria: ['Successfully create a judging criteria.', '创建评审准则成功'],
      editJudgingCriteria: ['Successfully edit a judging criteria.', '编辑评审准则成功'],
      removeJudgingCriteria: ['Successfully remove a judging criteria.', '删除评审准则成功'],
      createEventFree: ['Successfully create an event, Your free trial has 7 days left.', '创建活动成功, 您的免费试用剩余7天'],
      fillApplicationForm: ['Please create application form first !', '请先创建申请表 ！'],
      createTickets: ['Please create tickets first !', '请先创建门票 ！'],
      sendBatchImportParticipants: [
        'Successfully sending request for batching import participants',
        '成功发送批量导入参与者的请求'
      ],
      batchImportParticipants: ['Successfully batch import participants', '成功导入参赛者'],
      sentInvitation: ['Successfully sent invitation to ${email}', '邀请函已成功发送'],
      judgingResultSubmitted: ['Your judging result has been submitted.', '你的评审结果已经提交'],
      verifyEmail: [
        'Thanks, you have successfully verified your email. Please login again in order to update your status.',
        '你已经成功验证邮箱，请重新登录以更新您的状态。'
      ],
      exportAccount: ['Successfully export account data, please check your email', '成功导出账号数据，请检查您的邮箱'],
      couponApplied: ['Apply coupon successfully', '优惠券码兑换成功'],
      createAward: ['Successfully created award', '创建奖项成功'],
      removeAward: ['Successfully removed award', '成功移除奖项'],
      updateAward: ['Successfully updated award', '奖项信息更新成功'],
      updateLearningResources: ['Successfully update learning resources.', '成功更新学习资源'],
      removeLearningResources: ['Successfully delete learning resources.', '成功删除学习资源'],
      createTopic: ['Successfully created theme', '创建主题成功'],
      removeTopic: ['Successfully removed theme', '成功移除主题'],
      updateTopic: ['Successfully updated theme', '主题信息更新成功'],
      createTicket: ['Successfully created ticket', '创建门票成功'],
      removeTicket: ['Successfully removed ticket', '成功移除门票'],
      updateTicket: ['Successfully updated ticket', '门票信息更新成功'],
      webhookSaved: ['Slack Webhook successfully saved', '更新Slack WebHook设置成功'],
      checkSMSBox: ['Please Check Your SMS Inbox', '请查看手机短信的验证码'],
      phoneVerified: ['Phone Verification Succeeded', '手机验证成功'],
      addManagers: ['Successfully added ${numManager} manager(s)', '成功添加 ${numManager} 名管理员'],
      addParticipants: ['Successfully added ${len} participant(s)', '成功导入 ${len} 名参赛者'],
      addJudges: ['Successfully added ${numJudge} judge(s)', '成功添加 ${numJudge} 名评审'],
      addMentors: ['Successfully added ${numMentor} mentor(s)', '成功添加 ${numMentor} 名导师'],
      addVolunteers: ['Successfully added ${numVolunteer} volunteer(s)', '成功添加 ${numVolunteer} 名志愿者'],
      groupAssigned: ['Group assigned', '成功更改队伍分组'],
      applicationFormCheckboxCreate: ['Application Form Created', '成功创建申请表'],
      applicationFormCheckboxUpdate: ['Application Form Updated', '成功更新申请表'],
      pageTemplateCreate: ['Page Template Created', '成功创建页面模版'],
      pageTemplateUpdate: ['Page Template Updated', '成功更新页面模版'],
      applicationFormQuestionUpdate: ['Application Form Question Updated', '成功更新申请表问题'],
      applicationFormSubmit: ['Your application has been submitted. Please wait for approval and you will be notified via email.', '你的申请提交成功！请等待审核和邮件通知'],
      acceptCandidate: ['Successfully accept candidate', '成功接受请求'],
      rejectCandidate: ['Successfully reject candidate', '成功拒绝请求'],
      selectTemplate: ['Successfully select template', '成功选择模版'],
      getSocialMediaPosts: ['Successfully fetched posts from Instagram', '从Instagram获取帖子成功'],
      deletePostSuccess: ['Successfully deleted posts', '删除帖子成功'],
      linkPostSuccess: ['Successfully publish the posts', '发布帖子成功'],
      unlinkPostSuccess: ['Successfully Unpublish the posts', '撤销发布帖子成功'],
      updateTaxSuccess: ['Successfully update tax setting', '成功更新税款设置'],
      toggleTaxEnabledSuccess: ['Successfully update tax setting', '成功更新税款设置'],
      updateRefundSettingSuccess: ['Successfully update refund setting', '成功更新退款设置'],
      addPayoutInfoSuccess: ['Successfully added payout method', '成功添加银行信息'],
      screeningEventFinishCheckout: ['Checkout process has completed, please wait for your invoice email and submit your application', '付款流程已完成，订单邮件将会发送至您的邮箱。请在付款成功后填写赛事加入申请表。'],
      unscreeningEventFinishCheckout: ['Checkout process has completed, please wait for your invoice email', '付款流程已完成，订单邮件将会发送至您的邮箱。'],
      copyCouponCode: ['Coupon redeem code copied to your clipboard', '优惠券兑换码已复制到剪贴板'],
      uploadSuccess: ['Upload success', '上传成功'],
      verificationEmailSent: ['Verification email sent, please check your inbox(or your spam list).', '验证邮件已发送，清查您的邮箱(或您的垃圾邮件)。']
    },
    info: {
      uploadYourFirstFile: [
        'Upload your previous projects to decrease the processing wait time',
        '请上传你的往期作品集用于通过资质审核'],
      checkEmailToResetPassword: [
        'Please check your email for further instruction to reset your password.',
        '请通过邮件重置你的密码'
      ],
      disableMentorFeature: ['Mentor feature has been successfully disabled.', '导师功能暂时暂停使用'],
      verifyEmail: ['Please verify your email', '请验证你的邮箱']
    },
    warning: {
      noAttendeeInEvent: [
        'No attendee in this event or attendee does not have phone number',
        '这个活动还没有参与者或者参赛者没有填写电话'
      ],
      alreadyAppliedXinshiCup: [
        'Your have already applied, it may take a couple of days to process. We will notify you once it\'s completed.',
        '你已经报名，需要几天处理。一旦完成，我们会通知您。'
      ],
      existingAccountUseOldPass: [
        'An account associated with this email has already existed, only your phone number will be updated',
        '与此电子邮箱关联的帐户已存在，只有您的电话号码会更新'
      ],
      noUserFound: ['No user found', '找不到用户'],
      ticketSoldOut: ['Tickets have been sold out', '门票已经售罄'],
      couponAmountLimit: ['Price after discount must be greater than $1.00; otherwise, it would be a free ticket.', '折扣后票价如果低于$1将变成免费票。'],
      userAlreadyHasTeam: ['User already has team', '用户已经加入团队'],
      noInvalidEmail: ['No valid email has been entered to be invited', '请输入有效邮箱'],
      alreadyHasRole: ['One or more user(s) already have role', '用户不可设置多个身份，请查看用户是否已有其他身份'],
      deleteTeamWithTeamMembers: [
        "Team can't be deleted when there is still other member on the team",
        '你的队伍里还有其他的队员，暂时不能解散'
      ],
      invalidEmail: ['${email} is not a valid email', '${email} 不是个有效邮箱'],
      notParticipantInEvent: ['${email} is not a participant of this event', '${email} 还未参加这次活动'],
      gradeAllCriteria: ['Please have a grade for all criteria.', '请为作品评分'],
      requiredField: ['Please fill out the required fields: name and slug and themes', '请填写必填信息:名称,网址和主题'],
      slugTaken: ['This slug has already been taken, try a new one', '此ID已被使用，请尝试用别的ID'],
      startBeforeEnd: ['Event time is not valid, start time should be after end time', '活动时间输入有误，开始时间必须在结束时间之前'],
      subBeforeEnd: ['Event time is not valid, submission deadline should be before end time', '活动时间输入有误，提交截止时间必须在结束时间之前'],
      startBeforeSub: ['Event time is not valid, start time should be before submission deadline', '活动时间输入有误，开始时间必须在提交截止时间之前'],
      promoteTeamsInLastRound: ['You have selected the last round.', '您选择了最后一轮。'],
      teamsNotSelected: ['You have not selected any teams.', '您未选择任何团队。'],
      cloneEventPassSlugCheckFirst: ['Please check you slug first.', '请重新确认您输入的网址。'],
      cancelStripeCheckout: ['You did not finish checkout process.', '您未完成支付流程。']
    },
    error: {
      someSubmissionsHaveBeenJudged: [
        'Some submissions have been judged, you need to reset all scores to proceed',
        '一些提交已经评分，您需要重置所有分数才能继续'
      ],
      captchaNotValid: [
        'Your session is expired, Please refresh page and try again', '会话已过期，请刷新页面重新注册'
      ],
      phoneAlreadyUsed: [
        'The phone number has been used',
        '电话号码已被使用'
      ],
      nameTooLong: [
        'Exceeds the maximum characters of name field',
        '超过名字的最大字符数'
      ],
      emailOrPhoneNotVerified: [
        'Please verify your email or phone number （Please Check Spam Email And Trust Hackhub）',
        '请验证您的电子邮箱或电话号码 （请检查垃圾邮箱并且信任Hackhub）'
      ],
      phoneVerificationFail: ['Phone verification failed', '电话验证失败'],
      numberAlreadyExisted: ['This number is already existed and verified', '此号码已经存在和验证'],
      invalidPhoneVerifyCode: ['Invalid phone verificaiton code', '无效的手机验证码'],
      eventNotFound: ['Event not found', '找不到活动'],
      alreadyInTeam: ['User is already in a team', '用户已经在一个团队中'],
      invalidInput: ['Invalid request information', '无效的输入信息'],
      teamFull: ['The team is full', '团队已满'],
      invalidPassword: ['Invalid password', '无效密码'],
      'stripe.amount': ['Amount must be at least 50 cents', '金额必须至少为50美分'],
      'stripe.exp_month': ['Your card has expired.', '您的卡已过期'],
      exceedMaxTeamSize: ['Cannot set team size more than ${max}', '无法将团队规模设置为${max}以上'],
      notAbleToPurchaseTicketNow: ['Not able to purchase ticket now', '现在不能购买票'],
      notAbleToNotTeam: ['Not able to reject a team member now', '现在不能拒绝团队成员'],
      notAbleToAcceptTeam: ['Not able to accept a team member now', '现在不能接受团队成员'],
      onlyParticipant: ['Sorry, only participants of the event can post comment.', '抱歉，只有参赛者才可以发表评论'],
      unknownError: [
        'Sorry, updating system, try again later',
        '抱歉，系统正在升级，稍后再试'
      ],
      emailNotYetVerified: [
        'Your email has not yet been verified. You must first verify your email before you can join any events. （Please Check Spam Email And Trust Hackhub）',
        '你的邮箱还没有被验证，在参加活动前请验证邮箱。（请检查垃圾邮箱并且信任Hackhub）'
      ],
      duplicateUsername: ['Username existed', '用户名已被使用'],
      sendBatchImportParticipants: [
        'Fail sending request for batching import participants',
        '无法发送批量导入参与者的请求'
      ],
      batchImportParticipants: ['Fail batch import participants', '批量导入失败'],
      notVerifyEmail: ['Unkown error occourred. Your email was not verified.', '请验证你的邮箱'],
      notParticipant: ['You are not a participant in this event anymore', '您不再是此活动的参与者'],
      notTeamLeader: ['You are not the leader of this team.', '你不是这个团队的队长'],
      notInTeam: ['You are not in this team anymore', '你不属于这个团队'],
      notRegister: [
        'Seems like this email is not registered. Right now we are not able to reset your password, but you can register one :)',
        '邮箱未被注册，邮箱暂时无法被验证'
      ],
      loginNotMatch: ['Sorry, the login cominbation does not match. Please try again.', '抱歉，账号或者密码错误'],
      confirmationEmailObjectNotFound: ['Confirmation object not found, please try again', '验证邮件记录未找到，请重新尝试'],
      emailNotVerified: ['Please verify your account first', '请先验证您的账号'],
      inviteTokenExpired: ['Invite token expired', '邀请码已过期'],
      failToSaveProfile: ['Fail to save profile object, please try again', '个人信息保存失败，请重新尝试'],
      submissionNotFound: ['Submission not found', '提交记录未找到'],
      teamNotFound: ['Team not found', '团队未找到'],
      alreadyAppliedJoinTeam: ["You have already applied to this team, please wait for the team creator's response", '您已经申请加入此团队，请等候团队创建者回复'],
      userNotInPendingList: ['User not in pending list', '参赛者未在待定列表中'],
      maxTeamSize: ['Destinated team size is greater than max team size', '您设置的团队人数超过了最大限制'],
      removeTeamCreator: ['Team creator can not be removed from team', '您不能将团队创建者移出团队'],
      judgingCriteriaNotFound: ['Judging criteria not found', '评审要求未找到'],
      judgeCriteriaMarkRange: ['Given mark is greater than max allowed', '评分超出最高分数'],
      awardAssignLimit: ['Number of team(s) earned this award has reached the limit', '获奖团队数量已达到最高限制'],
      awardAlreadyAssigned: ['This team has earned this award', '此团队已获得此奖项'],
      awardNotFound: ['Award not found', '奖项未找到'],
      themeNotFound: ['Theme not found', '主题未找到'],
      premissionError: ['Permission error', '权限错误'],
      roleNotFound: ['Role not found', '角色未找到'],
      ticketNotFound: ['Ticket not found', '赛事门票未找到'],
      eventEnded: ['Event(ticket) has ended', '赛事(门票)已结束'],
      ticketAlreadyPurchased: ['You have purchased a ticket for this event previously', '您已经为此赛事购买了门票'],
      chargeNotFound: ['Charge object not found', '购买记录未找到'],
      jcMaxScore: ['Judging criteria max score is 100', '评分最大值为100'],
      teamCreatorCannotLeave: ['Team creator is not able to leave team, but delete team', '团队创建者可以删除团队，不能离开团队'],
      accountIsNotVerified: ['Account is not verified', '账号未验证'],
      eventHasEnded: ['Event has ended', '赛事已结束'],
      resourceNotFound: ['Learning resource not found', '学习资料未找到'],
      submissionDDLPast: ['Submission deadline has past', '提交截止时间已过'],
      noPermission: ['This action is forbidden', '您没执行此操作的权限'],
      resetPwdCodeNotFound: ['Reset password code not found', '重置密码验证码未找到'],
      teamNotFoundAlter: ['Team not found', '团队未找到'],
      GroupNotFound: ['Group not found', '分组未找到'],
      unknownThirdParty: ['Unknown third party name', '未知第三方平台名称'],
      formTokenUrlError: ['Fail generated third party login url', '生成第三方登录url错误'],
      accAlreadyBindWithThirdParty: ['HackHub account already binds with the third party account', '黑咖账号已和第三方账号绑定'],
      failToSaveInfo: ['Fail to save object', '保存信息失败'],
      failToFetchEmailFromLinkedinAcc: ['Failed to read email from linkedin account', '从领英账号中读取邮箱失败'],
      failToFetchInsToken: ['Failed to read instagram token', '获取instagram令牌失败'],
      ChannelObjectNotFound: ['Channel object not found', '频道信息未找到'],
      invalidUserPlan: ['Invalid user plan found', '错误用户套餐'],
      attendeesNumberLimit: ['Your event attendees sum number has reached the limit', '您赛事的参赛人数已达到您付费套餐的最大限制'],
      CSVFormat: ['CSV format error', 'CSV文件格式错误'],
      teamNotMatched: ['Team not matched', '团队不匹配'],
      failToReadFile: ['Failed to read file', '读取文件失败'],
      failToRemoveFromMailChimp: ['Failed to remove from email list', '删除邮箱列表失败'],
      invalidDate: ['Invalid date', '无效日期'],
      differentIP: ['Different IP is used', '检测到不同IP'],
      loginExpired: ['Login expired', '登录已过期'],
      incorrectRoleWhenDeleteAccount: ['Only account with participant for signup role is able to delete account', '您在账号创建时没有选择参赛者作为角色'],
      userDataExportInProgress: ['User data export in progress', '用户数据正在导出'],
      couponCodeExists: ['Same coupon code exists', '相同折扣码已存在'],
      couponRanOut: ['Coupon ran out', '折扣码已无效'],
      minTicketPrice: ['Min ticket price is $1', '最低票价为$1'],
      noFund: ['No availble fund', '您未拥有任何余额'],
      insufficientFund: ['Insufficient fund, please contact tech support info@hackhub.com', '余额不足，请联系技术支持 info@hackhub.com'],
      internalServer: ['Internal server error', '微服务错误'],
      videoNotFound: ['Video not found', '视频未找到'],
      invalidFileType: ['Invalid file type', '无效文件类型'],
      duplicateEmail: ['Email already existed in our system.', '此邮箱已存在'],
      invalidCoupon: ['Invilid coupon, please try again', '无效的优惠券码，请重试'],
      invalidEmail: ['Invalid Email', '无效邮箱'],
      invalidToken: ['Your login info is expired, Please relogin', '您的登录信息已过期，请尝试重新登录'],
      invalidUser: [
        'User profile error, please register again.',
        '用户类型错误，请重新注册'
      ],
      nopermission: [
        'User permission error, need creator permission. Free trial user can only create one event.',
        '用户权限不足，需要创建者权限, 试用用户只可以创建一个活动'
      ],
      backendError: ['Error, code ${code}, $message', '此功能系统在升级'],
      invalidPhone: ['Invalid phone number', '请填写一个有效电话号码'],
      webhookNotSaved: ['Sorry, Slack webhook was not saved successfully.', '抱歉，Slack Webhook还没有设置成功'],
      incorrectWebHookLink: [
        'Sorry, the Slack webhook link does not seem correct. Please try again.',
        '抱歉，Slack Webhook似乎不太对'
      ],
      phoneNotVerified: ['Phone Verification Failed: Wrong Code', '验证码有误'],
      actionFailed: ['Action Failed，try login again.', '操作无效，尝试重新登录'],
      uploadFailed: ['Upload Action Failed，try upload again.', '上传失败，尝试重新上传'],
      applicationFormCheckboxUpdate: ['Update Application Form Field Error', '更新申请表失败'],
      applicationFormCheckboxCreate: ['Create Application Form Field Error', '创建申请表失败'],
      applicationFormQuestionUpdate: ['Update Application Form Question Error', '更新申请表问题失败'],
      applicationFormSubmit: ['Your application submitted error. Please contact hackhub tech team info@hackhub.com.', '你的申请提交失败，请联系Hackhub技术人员 info@hackhub.com'],
      noInvalidEmail: ['No valid email has been entered to be invited', '请输入有效邮箱'],
      missRequiredFields: ['Missing required fields', '请填写完整信息'],
      failFetchSocialMediaPosts: ['Failed to fetch posts from Instagram', '从Instagram获取帖子失败'],
      zeroSocialMediaPosts: ['Can not find any posts with submitted tags', '找不到包含提交内容的帖子'],
      noPostsSelected: ['Have not selected any post, please select at lease one post', '没有选择帖子，请至少选择一个帖子再进行操作'],
      deletePostFailed: ['Failed to delete posts', '删除帖子失败'],
      linkPostFailed: ['Failed to publish the posts', '发布帖子失败'],
      unlinkPostFailed: ['Failed to unpublish the posts', '撤销发布帖子失败'],
      removeProfileFailed: ['Failed to delete account', '删除账号失败'],
      couponNotFound: ['Sorry, coupon is invalid', '对不起，优惠券不存在'],
      invalidRoundNumber: ['Invalid round number, please contact support info@hackhub.com.', '错误轮次，请联系技术支持 info@hackhub.com。'],
      invalidPromoteTeamsNumber: ['Selected teams total does not match server fetch data, please refresh page or contact support info@hackhub.com.', '选择团队数量与后台数据不符，请刷新页面或联系技术支持 info@hackhub.com。'],
      multiRoundDeadlineFormat: ['Multi round deadline must be between pervious and next round deadline.', '多轮赛事截止日期时间需在前一轮与后一轮之间。'],
      teamOrSubExistsWhileRemovingMultiRound: ['You can not remove round when teams or submissions exist in any selected rounds. Please contact support info@hackhub.com if you want to continue this action.', '您不能将含有团队或团队上传文件的轮次删除。请联系技术支持 info@hackhub.com 如果您想继续此操作。'],
      screeningPendingListNotEmpty: ['Your application screening list not empty, please handle all pending application before you turn off screening.', '您的筛选列表仍有未处理的申请，请在关闭申请前处理完所有的未处理申请。'],
      submitSelectWrongRound: ['Please select a valid round.', '请选择一个在截止时间前的轮次'],
      submitTeamNotInRound: ['Your team is not promoted into selected round. Please contact event organizer.', '您的团队不在您选中的轮次当中。请联系赛事举办方。'],
      fileUploadLimitReached: ['Your account has uploaded too frequent or too many large files. If you insist please email info@hackhub.com.', '您的账号上传的次数和上传文件总大小已超过我们的限制。请邮件联系 info@hackhub.com。'],
      createApplicationForm: ['Create application form error, please email tech support info@hackhub.com.', '创建申请赛事表单错误，请联系技术支持 邮箱 info@hackhub.com。'],
      stripeOnboardingLinkInvalid: ['Add payout method session has been expired', '添加支付信息超时'],
      refundedSomewhereElse: ['Transcation was refunded somewhere else', '此支付记录已从别处退款'],
      payoutMethodAlreadyAdd: ['Payout method already added', '银行信息已经添加'],
      payoutMethodNotFound: ['Payout method not found', '银行信息未设置'],
      stripeRelatedAPICallFreq: ['Actions are triggered too frequently', '操作过于频繁，请稍后重试'],
      taxRateExitsAlready: ['Tax rate exists already, please refresh the page', '税款已存在，请刷新页面'],
      invalidCouponAmount: ['Invalid coupon amount, price must higher than $3 after applying any coupon', '无效优惠券数额，优惠后的票价必须高于 $3'],
      stripeAccountExist: ['Stripe Account exists already', 'Stripe 账号已存在'],
      multipleAccountDetected: ['Multiple stripe account detected, please contact support info@hackhub.com', '多个 Stripe 账号存在，请联系技术支持 info@hackhub.com'],
      participantsRefundDDLGTEventStart: ['Participants refund deadline can not be after event start time', '参赛者退款截止时间不能晚于赛事开始时间'],
      invalidCouponExpiredTime: ['Invalid coupon expire time, expire time must be at least two minute later than current time.', '无效优惠券截止日期，截止日期须至少两分钟晚于创建时间。'],
      incorrectThirdPartyPlatformGithub: [
        'Your choose third platform is different than your choice last time, please try login through Github and use the same email.',
        '您此次选择的第三方登录平台不同于您上次的选择，请您使用相同邮箱于Github登录。'
      ],
      incorrectThirdPartyPlatformLinkedIn: [
        'Your choose third platform is different than your choice last time, please try login through LinkedIn and use the same email.',
        '您此次选择的第三方登录平台不同于您上次的选择，请您使用相同邮箱于LinkedIn登录。'
      ],
      incorrectThirdPartyPlatformGoogle: [
        'Your choose third platform is different than your choice last time, please try login through Google and use the same email.',
        '您此次选择的第三方登录平台不同于您上次的选择，请您使用相同邮箱于Google登录。'
      ],
      emailVerifiedAlready: [
        'Either your account has been verified or the verification code is invalid, please try login again.',
        '您的账号已经通过验证或您的验证码不正确，请尝试重新登录。'
      ],
      emailVerificationCodeExpired: [
        'Email verification link has been expired. Please try resend new email verification link.',
        '您的邮箱验证链接已过期，请尝试重新发送新邮箱验证链接。'
      ],
      actionsTooFreq: ['Action preformed too many times.', '您的操作过于频繁，请稍后重试。'],
      emailVerificationStateUpdateFailed: [
        'Email verification status update failed, please login again to update your email verification status.',
        '邮箱验证状态更新失败，请您重新登录。'
      ],
      fillInRequiredFields: ['Please fill in all required fields', '请填写所有必填项'],
      passwordNotMathed: ['Password not matched', '密码不匹配'],
      invalidIP: ['Invalid IP found', '无效IP'],
      accountExists: ['Account already exists', '账号已存在'],
      accountAlreadyEmailVerified: ['Account has been verified', '账号已通过验证'],
      verificationEmailResendExceedLimit: [
        'Verification email resend time exceeds limit, please contact support info@hackhub.com',
        '您的验证邮件重发次数以超过限制，请联系支持 info@hackhub.com'
      ],
      failedToSendEmail: ['Fail to send email, please contact support info@hackhub.com', '发送邮件失败, 请联系支持 info@hackhub.com'],
      invalidVerificationCode: ['Invalid verification code', '无效验证码'],
      socialLoginHHAccWithSameEmailExists: [
        'We found an account with email ${email} already exists, please use this email to login through HackHub.',
        '我们在系统中找到一个使用相同邮箱 ${email} 的账号，请使用这个邮箱登录在HackHub平台登录。'
      ],
      failedToFetchRequiredInfoFromThirdParty: [
        'Failed to fetch required info such as email from selected third party, this could caused by the privacy setting of your third party account.',
        '我们为能从您的第三方账号中获取必填信息(邮箱地址等)，原因可能是您第三方账号的隐私设置为将这些信息授权于HackHub。'
      ],
      socialLoginHHAccWithSameEmailExistsAlter: [
        'We found an account with the same email you have in the third party account already exists, please use this email to login through HackHub.',
        '我们在系统中找到一个邮箱和您的第三方账号邮箱一致的账号，请使用这个邮箱登录在HackHub平台登录。'
      ],
      passGoogleRecaptchaFirst: ['Please check recaptcha before proceed.', '请先完成人机校验。']
    }
  },
  uploader: {
    text: {
      loading: ['Loading', '载入中'],
      dragAndDrop: ['Drag & Drop here', '拖放到这里'],
      selectFile: ['Select File', '选择文件']
    },
    button: {
      close: ['Close', '关闭'],
      upload: ['Upload', '上传'],
      clear: ['Clear', '重置']
    }
  },
  common: {
    school: [
      'School',
      '学校'
    ],
    company: [
      'Company',
      '公司'
    ],
    streamUrl: [
      'Stream Url',
      '流网址'
    ],
    streamKey: [
      'StreamKey',
      '流密钥'
    ],
    countryDialCode: [
      'Country Dial Code',
      '国家拨号代码'
    ],
    phoneNumber: [
      'Phone Number',
      '电话号码'
    ],
    totalParticipants: [
      'Total Participants: ${totalParticipants}',
      '总参与者: ${totalParticipants}'
    ],
    totalCandidates: [
      'Total Candidates: ${totalCandidates}',
      '总申请人: ${totalCandidates}'
    ],
    liveStreaming: ['Event Channel', '赛事频道'],
    checkSlugHasBeenTaken: [
      'Check if slug has been taken',
      '检查url是否已被采用'
    ],
    organizational: ['Management Skill', '组织能力'],
    proficiency: ['Occupation Proficiency', '专业能力'],
    innovation: ['Innovation', '创新能力'],
    leadership: ['Leadership Ability', '领导能力'],
    insight: ['Observation Ability', '洞察力'],
    abilities: ['Abilities', '能力'],
    resources: ['Learning Resources', '学习资源'],
    viewLargerMap: ['View larger map', '查看详细地图'],
    getDirections: ['Get directions', '查看路线'],
    wechatMiniApp: ['WeChat mini program', '微信小程序'],
    usaCanda1: ['USA/Canada + 1', '美国/加拿大 +1'],
    china86: ['China +86', '中国 +86'],
    korea82: ['Korea +82', '韩国 +82'],
    hongkong852: ['Hong Kong +852', '香港 +852'],
    macou853: ['Macau +853', '澳门 +853'],
    taiwan886: ['Taiwan +886', '台湾 +886'],
    japan81: ['Japan +81', '日本 +81'],
    singapore65: ['Singapore +65', '新加坡 +65'],
    everyone: ['everyone', '大家'],
    projects: ['Projects', '作品'],
    approved: ['Approved', '批准'],
    nationality: ['Nationality', '国籍'],
    role: ['Role', '角色'],
    name: ['Name', '姓名'],
    regularName: ['Name', '名字'],
    approvedParticipants: ['Approved Participants', '批准参赛者'],
    checkInNum: ['CheckIn Number', '签到人数'],
    screening: ['Screening', '筛查'],
    rejected: ['Rejected', '未通过'],
    location: ['Location', '地点'],
    address1: ['Address line 1', '地址栏1'],
    address2: ['Address line 2', '地址栏2'],
    city: ['City', '城市'],
    province: ['State/Province', '省'],
    postalCode: ['Postal code', '邮政编码'],
    country: ['Country', '国家'],
    platform: ['Platform', '平台'],
    email: ['Email', '邮件'],
    sms: ['SMS', '短信'],
    judged: ['Judged', '已评分'],
    matchingScore: ['Matching Score', '匹配分数'],
    applied: ['Applied', '已申请 '],
    pending: ['Pending', '待审核'],
    join: ['Join', '加入'],
    full: ['Full', '满了'],
    submittedAt: ['Submitted at', '递交时间'],
    members: ['Members', '队员'],
    open: ['Open', '公开'],
    closed: ['Closed', '隐藏'],
    hidden: ['Hidden', '关闭'],
    remaining: ['Remaining', '剩余'],
    sold: ['Sold', '已售出'],
    soldOut: ['Sold Out', '售罄'],
    finished: ['Finished', '完成'],
    private: ['Private', '未公开'],
    public: ['Public', '公开'],
    ok: ['Ok', '好'],
    orderNumber: ['Order #', '订单号'],
    success: ['Success', '成功'],
    warning: ['Warning', '警告'],
    info: ['Info', '信息'],
    error: ['Error', '错误'],
    confirm: ['Confirm', '确认'],
    creditCard: ['Credit Card', '信用卡'],
    all: ['All', '所有'],
    participant: ['Participant', '参赛者'],
    judge: ['Judge', '评审'],
    mentor: ['Mentor', '导师'],
    volunteer: ['Volunteer', '志愿者'],
    siteTitle: ['HackHub', '黑咖创客'],
    free: ['Free', '免费'],
    ticket: ['Ticket', '收费'],
    judgingCriteria: ['Judging Criteria', '评审准则'],
    awards: ['Awards', '奖项'],
    coupons: ['Coupons', '优惠券'],
    topics: ['Themes', '主题'],
    patents: ['Patents', '专利'],
    checkOut: ['Check Out', '离开'],
    checkIn: ['Check In', '签到'],
    announcement: ['Announcement', '公告'],
    details: ['Application Details', '申请详情'],
    loginToSee: ['Please login to view', '请登录后查看'],
    userGuide: ['User Guide', '用户手册'],
    contactUs: ['Contact Us', '联系我们'],
    hasSignup: ['Signup', '已注册'],
    counts: ['Count(s)', '数量'],
    others: ['Others', '其他'],
    organizer: ['Organizer', '组织者'],
    freeEvent: ['Free Event', '免费活动'],
    shareToFriends: ['Share to friends', '分享']
  },
  headTitle: {
    resetPasswordForm: ['Reset Password | HackHub', '重置密码 | 黑咖创客'],
    hackOurWay: ['Hack our way <br/> through the jungle.', '披荆斩棘，一起黑客松吧。'],
    shapingFuture: ['Shaping the Future of <br/>  Team Building', '能力共享 <br/> 创客无界'],
    featured: ['Featured', '推荐'],
    events: ['Events', '比赛'],
    groups: ['Groups', '群聊'],
    creativeTeamWork: ['Creative Teamwork Made Easy', '让创意团队合作变得容易'],
    creativeTeamWorkPara: ['HackHub Event works with industry experts, leading companies, educational institutions and incubators to elevate individuals’ creativity. Through online and offline hackathon events, HackHub provides the ultimate platform that reinforces the professional growth for companies and talents.', 'HackHub Event 与行业专家、领先公司、教育机构和孵化器合作，以提升个人的创造力。通过线上和线下的黑客马拉松活动，HackHub 为企业和人才提供了促进专业成长的终极平台。'],
    positions: ['Positions', '在招'],
    hiring: ['Hiring', '职位']
  },
  anchor: {
    signUp: ['Sign Up', '注册'],
    signUpForAcccount: ['Sign up for an account', '注册账号'],
    forgotPassword: ['Forgot Password?', '忘记密码？'],
    backToHomepage: ['Back to homepage', '回到主页']
  },
  tab: {
    resume: ['My Resume', '我的简历'],
    hackhubProjects: ['HackHub Projects', '黑咖创客作品'],
    githubProjects: ['GitHub Projects', 'GitHub 作品'],
    extraProjects: ['Upload Projects', '上传的作品'],
    eventProjects: ['Event Projects', '活动作品'],
    eventAttended: ['Event Attended', '参加的活动'],
    popularEvents: ['Popular Events', '热门比赛'],
    popularGroups: ['Popular Groups', '热门群组']
  },
  button: {
    confirm: ['Confirm', '确认'],
    deleteEvent: ['Delete Event', '删除活动'],
    awardMode: ['Award Mode', '奖项模式'],
    submissionMode: ['Submission Mode', '作品模式'],
    addLinkedinCertification: ['Share project in LinkedIn', '分享作品到LinkedIn'],
    publicJudgeComments: [
      "Public Judges' Comments",
      '公开评委评价'
    ],
    hideJudgeComments: [
      "Hide Judges' Comments",
      '隐藏评委评价'
    ],
    makeAllSubmissionsPublic: [
      'Make All Submissions Public',
      '公开所有作品'
    ],
    makeAllSubmissionsPrivate: [
      'Make All Submissions Private',
      '隐藏所有作品'
    ],
    backToHomepage: ['Back to Homepage', '返回首页'],
    resetRankingScores: [
      'Reset All Scores',
      '重置所有分数'
    ],
    generateCSVFile: [
      'Generate CSV file',
      '生成csv文件'
    ],
    uploadPreviousProjects: ['Upload Previous Projects', '上传往期作品'],
    download: ['Download ${fileName}', '下载 ${fileName}'],
    fetch: ['Fetch Data', '获取数据'],
    check: ['Check', '检查'],
    open: ['Open', '打开'],
    generateAPI: ['Generate API', '生成API'],
    processing: ['Processing...', '处理中...'],
    registerNow: ['Register now', '现在报名'],
    getVerificationCode: ['Get verification code', ' 获得验证码'],
    uploadResume: ['Upload Resume', '上传简历'],
    updateResume: ['Update Resume', '更新简历'],
    accept: ['Accept', '接受'],
    reject: ['Reject', '拒绝'],
    delete: ['Delete', '删除'],
    upload: ['Upload', '上传'],
    approve: ['Approve', '加入'],
    disapprove: ['Disapprove', '移除'],
    loadMore: ['Load More...', '读取更多...'],
    clearAllNotifications: ['Clear All Notifications', '清除所有通知'],
    login: ['Login', '登录'],
    verifyEmail: ['Verify Your Email', '验证你的邮件地址'],
    loginToApply: ['Login to Apply', '登录申请'],
    applyJoinTeam: ['Apply to Join Team', '申请加入团队'],
    sendAgain: ['Send Again', '重新发送'],
    submit: ['Submit', '提交'],
    signUpToJoin: ['Sign Up to Join', '注册加入'],
    gotIt: ['Got it', '知道了'],
    ok: ['Ok', '好'],
    add: ['Add', '添加'],
    next: ['Next', '下一步'],
    prev: ['Prev', '上一步'],
    skip: ['Skip', '跳过'],
    done: ['Done', '完成'],
    back: ['Back', '返回'],
    checkout: ['Proceed to checkout', '进行结算'],
    pay: ['Pay', '付款'],
    getTicket: ['Get Ticket', '取票'],
    sendRequest: ['Send Request ', '联系'],
    downloadPdf: ['Download PDF', '下载 PDF'],
    cancel: ['Cancel', '取消'],
    edit: ['Edit', '编辑'],
    save: ['Save', '保存'],
    yes: ['Yes', '是'],
    no: ['No', '否'],
    onlineCheckin: ['Online Check-In', '线上签到'],
    countdown: ['Countdown', '倒计时'],
    chinese: ['CH', '中文'],
    english: ['EN', '英文'],
    lang: ['EN', 'CH'],
    go: ['Go', '转到'],
    select: ['Select', '选择'],
    contact: ['Contact Organizer', '联系主办方'],
    quit: ['Quit', '退出'],
    cloneEvent: ['Clone Event', '复制赛事'],
    exploreMoreEvents: ['Explore More Events', '探索更多比赛'],
    exploreMoreGroups: ['Explore More Groups', '探索更多群组'],
    exploreMorePositions: ['Explore More Positions', '探索更多在招'],
    createNewAccount: ['Create new account', '创建新账号'],
    cancelSocialLogin: ['Cancel social login', '取消第三方登录'],
    acceptPolicy: ['Accept all cookies', '接受所有cookies'],
    getDemo: ['Get a demo', '了解一下'],
    subscribe: ['Subscribe', '订阅'],
    learnMore: ['Learn more', '了解更多']
  },
  table: {
    columns: ['Columns', '信息显示'],
    actions: ['Actions', '操作'],
    search: ['Search...', '搜索...'],
    rowsSelected: ['rows selected ', '已选 ']
  },
  text: {
    or: ['or', '或'],
    enterSlugMessage: [
      'Please type in the slug (${eventSlug}) of the event to confirm.',
      '请输入活动的 slug（${eventSlug}）进行确认'
    ],
    welcomeToHackHub: [
      'Hello! Welcome to HackHub',
      '你好，欢迎来到黑咖创客'
    ],
    emailIsMandatory: [
      '*Email is mandatory',
      '*电子邮件必填'
    ],
    presentToOrganizerWhenCheckInOut: [
      'Present QR code to organizer to check in/out',
      '向主办单位出示二维码以签入,签出'
    ],
    copyFollowingToVideoPlayer: [
      'Configure your video player with following settings',
      '使用以下设置配置视频播放器'
    ],
    profileStepEditProfile: [
      'Edit profile : you can edit your personal information and status here',
      '编辑个人资料：您可以在此处编辑您的个人信息和状态'
    ],
    profileStepEditSocial: [
      'Edit social media and upload your resume: We want to know you better! You can link your social media to HackHub here.',
      '编辑社交媒体并上传您的简历：我们想更好地了解您！你可以在这里将你的社交媒体链接到黑咖创客。'
    ],
    profileStepViewGithub: [
      'Update your GitHub id. Then, you are able to see your github public projects over here',
      '更新你的GitHub ID。然后，你可以在这里看到你的github公共项目'
    ],
    profileStepDone: [
      'Let’s begin your HackHub experience!',
      '让我们开始您的黑咖创客体验吧!'
    ],
    scanToUploadProjects: [
      'Scan to upload your projects', '扫码上传您的作品'
    ],
    expireTokenHeader: [
      'It seems like your token has been expired, you will be logged out in ${second}',
      '您的token已过期, 你将在${second}秒被登出'
    ],
    clickLoginOnPhone: ['Please confirm to login on your mobile device', '请在手机上确认登入'],
    loginWithPassword: ['Login with password?', '用密码登录?'],
    loginWithQRCode: ['Login with QR code?', '用二维码登录?'],
    confirmToJoinTeam: [
      'Do you want to join ${teamName}',
      '你想要加入${teamName}吗'
    ],
    confirmToRemoveCreditCard: [
      'Do you want to remove this credit card?',
      '你想删除这张信用卡吗？'
    ],
    noTicketsAvaliableContactOrganizer: [
      'No tickets available right now. Please wait the organizer sets it.',
      '目前没有门票。请等待主办方设置它。'
    ],
    weSentConfirmationEmail: [
      'We’ve sent a confirmation email to <strong>${email}</strong>. Please check you inbox and spam folder.',
      '我们已发送确认电子邮件给 <strong>${email}</strong>。请检查你的邮箱包括垃圾邮箱。'
    ],
    pleaseCheckInbox: [
      'Please check your inbox including Spam',
      '请检查您的邮箱包括垃圾邮箱'
    ],
    oneMoreStepAway: [
      'One more step away!',
      '只差一步'
    ],
    cannotMakeChangeToMarks: ['You cannot make additional changes after submission.', '提交后无法进行其他更改'],
    howDidTeamDo: ['How well did <i>${team}</i> do', '<i>${team}</i>的表现如何'],
    someoneWantsToJoin: ['Someone wants to join', '有人想加入'],
    waitForMe: ['Wait for me', '等等我'],
    notifyWhenAccpeted: [
      'We will notify you via email when the project host accepts your application!',
      '当队长接受您的申请时，我们会通过电子邮件通知您！'
    ],
    appliedToJoinTeam: ['You have applied to join\n${team}', '你已经申请加入\n${team}'],
    scores: ['${score} scores', '最高分数: ${score}'],
    awardLimit: ['${limit} limit', '奖项数量: ${limit}'],
    couponLimit: ['coupon quantity: ${quantity}', '优惠券数量: ${quantity}'],
    couponAmount: ['coupon amount:', '优惠价格:'],
    submitOneOfFollowing: [
      'Please submit at least one of the following. A Website link, Video link, a GitHub link or a zip file!',
      '请至少上传以下一项：网站链接，介绍视频连接、开源GitHub链接 或者 上传一个zip文件。'
    ],
    privateSubmission: ['This is a private submission.', '非公开作品'],
    skills: ['SKILLS', '技能'],
    video: ['VIDEO', '视频'],
    links: ['LINKS', '链接'],
    topics: ['THEMES', '主题'],
    description: ['DESCRIPTION', '描述'],
    rules: ['DESCRIPTION', '描述'],
    comment: ['COMMENT', '评语'],
    createEvent: ['Create Event', '创建比赛'],
    comfortableView: ['Comfortable View', '展示'],
    compactView: ['Compact View', '列表'],
    congratSuccessSubmission: ['Congrats! You submitted your project.', '恭喜你，你已经成功提交了作品。'],
    teamWereJudged: ['submissions were judged', '项目已被给予评分'],
    judgeWillJudge: ['Judges will judge your submission later.', '评审将会随后给出评分'],
    selectAwardQuestion: ['Which award do you want (multiple choice)?', '想参与哪个奖项（可多选）？'],
    selectTopicQuestion: ['Which theme do you want (multiple choice)?', '想参与哪个主题（可多选）？'],
    selectTicketType: ['Select Ticket Type', '选择票种'],
    sendNewAnnouncement: ['New Announcement', '发布新公告'],
    goToInvoicesPageToRefund: ['Go to invoices page to refund', '请前去订单页面申请退款'],
    invoiceDataDownload: ['Invoices CSV Export', '订单CSV导出'],
    dontHaveAccount: ['Don’t have an account?', '还没有帐号？'],
    backToHomepage: ['Back to Homepage?', '返回首页？'],
    hasNoTicket: ['You have no ticket', '你暂时没有门票'],
    noTicketAvaliable: ['No Ticket Available', '门票售罄'],
    discoverEvents: ['Discover Events', '参与其他活动'],
    purchasedOn: ['Purchased on ${date}', '购买日期 ${date}'],
    orderNumber: ['Order #${orderNum}', '订单号 ${orderNum}'],
    refunded: [' $${refundedAmt} Refunded', ' $${refundedAmt} 已退款'],
    nextStepToSetAward: ['Next Step: Define Awards', '下一步，设置奖项'],
    nextStepToInviteParticipants: ['Next Step: Invite Attendees', '下一步，邀请参赛人员'],
    refundAmtToEmail: ['Refund $${amt} to ${email}?', '是否要将 $${amt} 退还给 ${email}？'],
    batchImport: ['If you would like to batch import participants, please ', '如果需要批量上传，'],
    toOurSupportTeam: ['to our support team', '我们的客服人员'],
    rankingShownAfterUpload: [
      'There are no project submissions at the moment. Wait for submission',
      '目前没有作品提交，当参赛者上传作品后，你便可看到相关作品信息。'
    ],
    joinEventSuccessMessage: [
      'It’s time to start creating your awesome team, or get an invitation from your friends!',
      '是时候召集你的小伙伴们一起黑咖了'
    ],
    notNow: ['Not Now', '等会再来找小伙伴'],
    joinFriendsTeam: ["Join Friend's Team", '加入小伙伴的团队'],
    screeningImportRequired: ['Delete the title in this template if the column is empty!', '请在表格中删除空列！'],
    onlineCheckin: ['This feature is used to allow articipants to check in by themselves and organizer can see the Participants checkin status in the <strong>Attendees</strong> tab.', '这个功能可以让选手自己在线签到，组织者可以在<strong>人员</strong>一栏查看选手签到状态。'],
    countdown: ['This feature is used for participants checking the submission count down more easily.', '这个功能用于给参赛者更方便查看作品截止倒计时。'],
    winPrize: ['Congradulations! Your team wins event ${eventName} prize ${award}', '恭喜！你的团队获得比赛${eventName}的${award}奖项'],
    demoSectionMessage: ['Best Solution to Host Hackathon Events', '最好用的黑客松举办及管理平台']
  },
  modal: {
    title: {
      termOfUseAndPrivacyPolicy: ['Terms of Use &amp; Privacy Policy', '法律声明及隐私权政策']
    },
    content: {
      resetScoreWarning: [
        'Are you sure to reset all scores?',
        '你确定重置所有分数吗？'
      ]
    },
    Message: [
      'Changing the role of ${email} will switch the attendee from a ${role} to a ${value}',
      '为这个用户${email}改变角色会使其从${role}变成${value}'
    ]
  },
  eventInfo: {
    description: [
      'All-in-one hackathon and management system',
      '一体化大型赛事云管理平台'
    ],
    freeTrial: [
      'Enjoy your 7-day free cloud trial',
      '免费发布赛事，体验7天会员试用'
    ],
    ticket: [
      'Ticket collection',
      '门票管理及报名推广'
    ],
    pageBuilder: [
      'Event homepage builder',
      '活动主页设计与开发工具'
    ],
    smartTeam: [
      'Smart team creation with skill matching',
      '基于技能匹配算法的智能在线组队'
    ],
    customizableForm: [
      'Customizable application form',
      '轻松定制专属报名系统'
    ],
    screening: [
      'Participant screening',
      '便捷的入场资格筛选体系'
    ],
    fastCheckIn: [
      'Paperless participants check-in and checkout',
      '基于二维码的快速签到验票'
    ],
    announcement: [
      'Email and SMS batch announcement',
      '邮件和短信群发功能'
    ],
    onlineSubmission: [
      'Online Project submission',
      '在线作品提交'
    ],
    mobileJuding: [
      'Mobile judging',
      '移动端在线评分'
    ],
    uniqueFeatures: [
      '30+ unique features designed by organizers',
      '30多项专为活动主办方定制的功能'
    ],
    zeroObligation: [
      'Zero obligation, no credit card needed',
      '零风险免费试用'
    ],
    support: [
      'Event technical support',
      '提供技术支持和比赛指导服务'
    ],
    multiRound: [
      'Multi-round competition',
      '多轮次晋级赛事'
    ],
    onlineHackathon: ['Online Hackathon', '在线黑客松'],
    inPersonHackathon: ['In-person Hackathon', '线下比赛'],
    hybridHackathon: ['Hybrid Hackathon', '混合比赛'],
    startsOn: ['Starts on', '起始'],
    endsIn: ['Ends in', '结束'],
    onlineEvent: ['Online', '线上比赛']
  },
  form: {
    reminder: {
      password: [
        'Alphabetic, numeric or at least 8 characters',
        '字母、数字或者英文符号，最短8位，区分大小写'
      ]
    },
    error: {
      async: {
        slugTaken: ['This slug has already been taken', '此ID已被使用']
      },
      moment: {
        afterStartDate: ['Must be after start date', '必须在开始时间之后'],
        betweenStartAndEndDate: [
          'Must be after start date and before end date',
          '必须在开始时间之后, 在结束时间之前'
        ]
      },
      regex: {
        phoneNumber: ['Invalid phone number', '无效的电话号码'],
        multipleEmail: [
          'Please provide multiple email addresses separated by commas without trailing comma',
          '请提供多个以逗号分隔的电子邮件地址，结尾不要使用逗号'
        ],
        alphaNumeric: ['Has special symbols or space', '必须是字母数字,没有空格'],
        githubUrl: ['Must be a GitHub link', '必须是GitHub链接']
      },
      mixed: {
        notType: ['Invalid value', '无效值'],
        required: ['Required field', '必填'],
        matchPasswords: ['Passwords do not match', '密码不匹配'],
        submitAtLeastOne: [
          'Please submit at least one of the following. A Video link, a GitHub link or a zip file!',
          '请至少提交以下其中一项。视频链接，GitHub链接或zip文件！'
        ]
      },
      boolean: {
        agreeIndication: ['Please indicate you have agreed with the above', '请同意上述内容']
      },
      array: {
        max: ['You reach the max limit: ${max}', '最多不超过${max}个'],
        min: ['You need at least: ${min}', '必须至少有${min}个']
      },
      number: {
        stripePrice: ['Price either free or more than 50 cents', '价格为免费或超过50分'],
        positive: ['Must be a positive number', '必须是一个正数'],
        max: ['Must be ${max} or less', '必须小于或等于${max}'],
        min: ['Must be ${min} or more', '必须大于或等于${min}'],
        invalid: ['Invalid number', '必须是数字']
      },
      string: {
        email: ['Must be a valid email', '必须是有效的邮箱'],
        url: ['Must be a valid url', '必须是有效的网址'],
        max: ['Must be at most ${max} characters', '必须至多为${max}个字符'],
        min: ['Must be at least ${min} characters', '必须至少为${min}个字符']
      },
      // added for input validation
      validate: {
        trim: ['Must not include space', '请勿包含空格'],
        letterOnly: ['Must be only letters without space', '只允许英文字母'],
        password: ['Password should include at least one number, one alphabet, one uppercase, one lowercase, special symbol', '密码应至少包含一个数字，大小写英文字母各一个，一个特殊字符'],
        mustDigitOnly: ['Must be only digits', '只允许数字'],
        digitOnly: ['Must be exactly ${min} digits', '须为 ${min} 位数'],
        alphabetAndIntOnly: ['Must contain only alphabet and integer', '须包含至少一个英文字母和一个数字'],
        applicationLimit: ['Must be within 1 to 200 characters', '字符长度应为1-200'],
        checkPrompt: ['Please check your input and try again', '您的输入无效，请重新尝试']
      }
    },
    confirmationTitle: {
      sureToUpdateAnnouncement: ['Do you want to update this announcement now?', ' 你确定要更新公告吗？'],
      sureToSendAnnouncement: ['Do you want to send this announcement now?', '你确定发送这个公告吗？'],
      sureToUpdateScreeningEmailTemplate: ['Do you want to update this screening email template now?', ' 你确定要更新筛选邮件模版吗？'],
      sureToUpdatePageTemplate: ['Do you want to update this page template now?', ' 你确定要更新页面模版吗？'],
      sureToDeletePageTemplate: ['Do you want to delete this page template now?', ' 你确定要删除这个页面模版吗？']
    },
    title: {
      inviteParticipant: ['Invite Participant', '邀请参赛者'],
      invoteMentor: ['Invite Mentor', '邀请导师'],
      inviteJudge: ['Invite Judge', '邀请评审'],
      inviteVolunteer: ['Invite Volunteer', '邀请志愿者'],
      addManager: ['Add Manager', '添加管理员'],
      addParticipant: ['Add Participant', '添加参赛者'],
      addJudge: ['Add Judge', '添加评审'],
      addMentor: ['Add Mentor', '添加导师'],
      addVolunteer: ['Add Volunteer', '添加志愿者'],
      signupUser: ['Create your account', '创建账户'],
      loginUser: ['Login to HackHub', '登陆黑咖账户'],
      signup: ['Create New Account', '创建新账号'],
      emailVerification: ['Verify Your Email', '验证您的邮箱地址'],
      selectYourRole: ['Select Your Role', '选择您的角色'],
      yourUsername: ['Your username', '您的用户名']
    },
    hint: {
      signupBasicAvatar: ['Click on the image below to upload a new profile picture.', '点击下方图片上传新头像'],
      signupBasicUsername: ['We have generated a unique username for you, you can only change it once.', '我们已经为您生成了一个唯一的用户名，您只可以修改一次'],
      signupBasicRole: ['Please specify your primary role.', '请选择您的主要职责'],
      accountFound: ['We found your account has been registered in HackHub,', '我们发现您的邮箱已经在HackHub注册过了'],
      bindAccount: ['click YES to bind your existing account, or click NO bind another account.', '点击是来关联已有账户，或者点击否来关联另一个账户。']
    },
    label: {
      nameNPhone: ['Name* and Phone Number(optional)'],
      username: ['Username', '用户名'],
      link: ['click to view', '点击浏览'],
      description: ['Description', '介绍'],
      url: ['URL', '网址'],
      pageName: ['Page Name', '页面名称'],
      previewUrl: ['Preview Url', '预览网址'],
      editUrl: ['Edit Url', '编辑网址'],
      mediaUrl: ['Media Url', '媒体网址'],
      githubUrl: ['GitHub Url', 'GitHub网址'],
      fileUrl: ['File Url', '文件网址'],
      resourceIsPublic: ['Resource Public To All', '该资源完全公开'],
      websiteUrl: ['Website Url', '网站链接'],
      student: ['Student', '学生'],
      employee: ['Employee', '员工'],
      verifyCode: ['Verification Code', '验证码'],
      countryDialCode: ['Country/Dial Code', '国家/拨号代码'],
      awards: ['Awards', '奖项'],
      patents: ['Patents', '专利'],
      socialMedia: ['Social Media', '社交媒体'],
      personalWebsite: ['Personal website', '个人网站'],
      designer: ['Designer', '设计师'],
      softwareEngineer: ['Software Engineer', '软件工程师'],
      dataAnalysis: ['Data Analysis', '数据分析师'],
      businsess: ['Bussiness', '商科'],
      humanResource: ['Human Resource', '人力资源'],
      finance: ['Finance', '金融'],
      marketing: ['Marketing', '市场'],
      health: ['Health', '大健康'],
      AI: ['AI', '人工智能'],
      productManager: ['Product Manager', '产品经理'],
      businessManager: ['Business Manager', '商业策划'],
      engineer: ['Engineer', '工程师'],
      role: ['Role', '角色'],
      major: ['Major', '专业'],
      schoolCompany: ['School/Company', '学校/公司'],
      sendType: ['Sending Type', '发送类型'],
      to: ['To', '发送对象'],
      emailTitle: ['Email Title', '邮箱标题'],
      message: ['Message', '公告详情'],
      time: ['Time', '时间'],
      changeRole: ['Change Role', '更改角色'],
      changeGroup: ['Change Group', '更改分组'],
      status: ['Status', '状态'],
      remove: ['Remove', '删除'],
      event: ['Event', '活动'],
      ticketName: ['Ticket Name', '门票名字'],
      orderNumber: ['Order #', '订单号'],
      price: ['Price', '价格'],
      paidDate: ['Paid Date', '付费日期'],
      refundDate: ['Refund Date', '退款日期'],
      refunded: ['Refunded', '已退款'],
      refund: ['Refund', '退款'],
      bio: ['Bio', '简介'],
      name: ['Name', '姓名'],
      title: ['Title', '标题'],
      email: ['Email', '邮箱'],
      emailAddress: ['Email Address', '邮箱地址'],
      password: ['Password', '密码'],
      phoneNumber: ['Phone Number', '电话号码'],
      school: ['School Or Company Name', '学校或者公司名字'],
      cityCountry: ['Which country and city are you in?', '在哪个国家和城市？'],
      confirmPassword: ['Re-enter Password', '重新输入密码'],
      sendVerificationEmail: ['Send Code', '发送验证码'],
      emailVerificationCode: ['Email Verification Code', '邮件验证码'],
      agreeToTermOfUse: ['By clicking below, you agree to the HackHub ', '点击下方，您将默认同意Hackhub的'],
      agreePolicy: [
        'By clicking \'Create new account\', you agree to the ',
        '点击创建新账号按钮，您将默认同意Hackhub的'
      ],
      policyName: ['Hackhub Terms of User & Privacy Policy', '法律声明及隐私权政策'],
      newsletterSubscription: [
        'Receive emails newsletters',
        '接收Hackhub产品讯息、活动的邮件'
      ],
      city: ['City', '城市'],
      agreeToContact: ['Hackhub is committed to protecting and respecting your privacy, and we’ll only use your personal information to provide the products and services you requested from us. If you consent to us contacting you for this purpose, please tick below to say you would like us to contact you as soon as possible:',
        'Hackhub 承诺保护和尊重您的隐私，我们只会将您的个人信息用于提供您要求的服务和产品。如果您同意我们联系您，请点击下方的按钮，我们将尽快安排人员和您对接。'],
      tags: {
        topSkills: ['Your Top ${num} Skills', '您的${ num }个技能']
      },
      highSchool: ['High School', '高中'],
      diploma: ['Diploma', '高等文凭'],
      college: ['College', '大专'],
      university: ['University', '大学'],
      master: ['Master', '研究生'],
      PhD: ['PhD', '博士'],
      education: ['Education', '教育'],
      profession: ['Profession', '专业'],
      label: ['Label', '名称'],
      pageTraffic: ['Page', '页面流量'],
      applicationTraffic: ['Application', '申请流量'],
      customDate: ['Custom', '自定义'],
      emailVerificationDescText: ['Enter the verification code received by ${email}', '输入发送至 ${email} 的验证码'],
      alertnativeSignup: ['Or sign up with', '或使用第三方注册'],
      location: ['Location', '地点'],
      rememberMe: ['Remember me', '记住我'],
      alertnativeLogin: ['Or Log in with', '或使用第三方登录'],
      dontHaveAccount: ['Don\'t have an account?', '没有账号?'],
      confirmNewPassword: ['Re-enter Your New Password', '确认您的新密码']
    },
    placeholder: {
      username: ['Username', '用户名'],
      verifyCode: ['111111', '111111'],
      personalWebsite: ['Personal website', '个人网站'],
      role: ['Role', '角色'],
      eventLocation: ['Event Location', '活动地点'],
      announcementContentTemplate: [
        'Hello ${role},\n${eventName} has a new announcement:\n',
        '${role}好,\n${eventName}有个公告:\n'
      ],
      searchProject: ['Search projects', '搜索作品'],
      searchHackathons: ['Search Hackathons', '搜索比赛'],
      searchHackathonsByName: ['Find hackthons by entering the names here.', '搜索比赛'],
      sortBy: ['Sort by', '排列顺序'],
      teamLimit: ['Team Limit...', '人数限制...'],
      to: ['To', '给'],
      bio: ['Bio', '简介'],
      name: ['Name', '姓名'],
      major: ['Major', '专业'],
      schoolCompany: ['School/Company', '学校/公司'],
      email: ['Enter email', '输入邮箱'],
      emailAddress: ['Enter your email address', '输入您的邮箱'],
      emailVerificationCode: ['Enter verification code', '输入验证码'],
      password: ['Enter password', '输入密码'],
      confirmPassword: ['********', '********'],
      firstName: ['First Name', '输入名字'],
      lastName: ['Last Name', '输入姓氏'],
      dialCode: ['Dial Code', '国际区号'],
      phoneNumber: ['778666666', '13688888888'],
      city: ['City', '城市'],
      tags: {
        topSkills: ['Select skills...', '例如： web [然后点击回车键]...']
      },
      location: ['Enter your city', '输入您的城市'],
      education: ['Select your education level', '选择您的学历'],
      reEnterPassword: ['Re-enter password', '确认密码']
    },
    submitBtn: {
      send: ['Send', '发送'],
      update: ['Update', '更新'],
      login: ['Login', '登录'],
      getStarted: ['Agree and Sign up', '同意并注册'],
      resetPassword: ['Reset Password', '重置密码']
    }
  },
  socialLogins: {
    google: ['Log in with Google', '使用Google账号登陆'],
    github: ['Log in with Github', '使用Github账号登陆'],
    linkedin: ['Log in with Linkedin', '使用Linkedin登陆']
  },
  xinshiSteps: {
    step1Tit: ['Step1', '步骤1'],
    step1Des: ['Signup and verify your phone number', '注册并验证您的电话号码'],
    step2Tit: ['Step2', '步骤2'],
    step2Des: ['Select the event you want to attend', '选择你想参加的活动'],
    step3Tit: ['Step3', '步骤3'],
    step3Des: ['Fill in your personal information', '填写您的个人信息'],
    step4Tit: ['Step4', '步骤4'],
    step4Des: [
      'Completed, Your application has been received, it may take a couple of days to process. We will notify you once it\'s completed.',
      '完成, 已收到您的申请，可能需要几天处理。一旦完成，我们会通知您。'
    ]
  },
  '(optional)': ['(optional)', '（可选项）'],
  Accept: ['Accept', '接受'],
  accepted: ['Accepted', '接受'],
  'Add Award': ['Add Award', '添加奖项'],
  'Add Coupon': ['Add Coupon', '添加优惠券'],
  'Add Topic': ['Add Theme', '添加主题'],
  'Add Judging Criteria': ['Add Judging Criteria', '添加评审要求'],
  'Add Learning Resource': ['Add Learning Resource', '添加学习资源'],
  'Add Page Template': ['Add Page Template', '添加页面模版'],
  'Add liveStreaming': ['Add LiveStreaming Workshop', '添加直播课程'],
  sendAnnouncement: ['Send Announcement', '发送公告'],
  'Add Application Form Question': ['Add Application Form Question', '添加申请表问题'],
  'Add Ticket': ['Add Ticket', '添加门票'],
  'All Teams': ['Teams', '参赛团队'],
  Applied: ['Applied', '已申请'],
  announcement: ['Announcement', '公告'],
  settings: ['Settings', '设置'],
  'Are you sure you want to leave': ['Are you sure you want to leave', '你确定要离开团队吗？'],
  'Are you sure?': ['Are you sure?', '您确定吗?'],
  Awards: ['Awards', '奖项'],
  Bio: ['Bio', '简介'],
  'Coming Soon': ['Coming Soon', '即将开始'],
  'Create Event': ['Create Event', '创建比赛'],
  'Create My Team': ['Create My Team', '创建团队'],
  'Create a Team': ['Create a Team', '创建一个新团队'],
  'Current Attachemnt': ['Current Attachemnt', '现有上传'],
  'Current Members': ['Current Members', '当前成员'],
  'Delete This Team': ['Delete This Project', '解散团队'],
  Description: ['Description', '介绍'],
  details: ['Details', '比赛详情'],
  'submission details': ['Submission Detail', '作品详情'],
  'Do you want to accept the team member?': ['Do you want to accept the team member?', '你确认接受这个申请吗？'],
  'Do you want to reject the team member?': ['Do you want to reject the team member?', '你确认拒绝这个申请吗？'],
  'Do you want to remove this team member?': [
    'Do you want to remove this team member?',
    '你确认将该成员从团队里面移出?'
  ],
  'Done Editing': ['Done Editing', '保存修改'],
  Download: ['Download', '下载'],
  'Edit Details': ['Edit Details', '修改比赛资料'],
  'Edit My Team': ['Edit Team', '修改团队资料'],
  eventDate: ['Date', '活动日期'],
  eventEnd: ['End', '活动结束'],
  'Event Page Subtitle': ['Meet New Connections. Ideas to Life.', 'Meet New Connections. Ideas to Life.'],
  'Event Page Title': ['Discover the Talent in You', '发掘你的潜在才能'],
  eventStart: ['Start', '活动开始'],
  'Event Type': ['Event Type', '活动类型'],
  eventPaidFree: ['Is it a free or paid event?', '这是免费活动还是付费活动？'],
  eventPaidFreeInstruction: ['HackHub can help you to collect ticket for paid events', '黑咖可以帮你收取票钱'],
  eventOnlineInPerson: ['Is it an online or in-person event?', '这是线上活动还是线下活动？'],
  eventPublic: ['Is it a public or invitation-only event?', '这是私人活动吗？'],
  eventPublicInstruction: ['Private hackathons will not be seen by public and will be invite only', '私人活动不会公开，只能通过邀请加入'],
  eventNeedScreen: ['Do you need to screen your candidates\'s applications?', '是否需要参赛者填写报名表'],
  eventNeedStreaming: ['Do you need to contain live streaming workshop for your event?', '您的活动是否需要支持多人会议或上传视频?'],
  eventNeedScreenInstruction: ['Allow you to create application forms and screen candidates\' initital submissions', '你可以为参与者创建一个申请表'],
  eventApplicationNote: [
    `Note: If you choose yes an application with default fields will be created for you, but you have to set it open to participants manually in event management page. 
    Applications on event.hackhub.com and event.hackhub.cn are seperated. If you plan to get applicants on .cn users, please remember to setup Chinese application form
    and set it open manually.`,
    `注意事项：如果您选择是，我们会给您自动创建一个默认申请表单。但您需要在赛事管理页面手动开启这个表单，否则用户将不能提交参赛申请。
    event.hackhub.cn 和 event.hackhub.com 上的申请表单是不同的。如果您计划在 .com 页面收集参赛申请，请记得设置英文申请表单并手动开启它。`],
  eventApplicationStart: [
    'When does the application start?',
    '参赛申请开始时间'
  ],
  eventApplicationStartHelpText: [
    'Participants can start to apply to participate the event after the start time.',
    '用户可在这个时间后开始提交申请。'
  ],
  eventApplicationEnd: [
    'When is the deadline of the applications?',
    '参赛申请结束时间'
  ],
  eventApplicationEndHelpText: [
    'The organizer stops receiving any application after the deadline. ',
    '用户不能在这个时间后提交申请。'
  ],
  eventWhere: ['Where will this event take place?', '这个活动在哪里举办？'],
  eventWhereInstruction: ['Leave it empty if it is an online event.', '如果是线上活动请留空。'],
  eventTimezone: ['Please select your timezone', '请选择你的时区'],
  eventWhenStart: ['When does the event start?', '活动开始时间'],
  eventWhenStartInstruction: ['Participants can start to make submissions after the start time.', '参与者在活动开始后可以提交'],
  eventWhenSubmissionDeadline: ['When is the submission deadline?', '提交的截止时间'],
  eventWhenSubmissionDeadlineInstruction: ['The submission portal will be closed after the deadline', '截止后将无法再提交'],
  eventWhenEnd: ['When does the event end?', '活动结束时间'],
  eventWhenEndInstruction: ['Participants cannot check-in after this time', '在这之后无法再check-in'],
  eventMoreDetails: ['Add more details about your event', '为你的活动增加更多细节'],
  eventMoreDetailsInstruction: ['You can always change the event design later in event dashboard', '活动细节可随时在设置中更改'],
  eventMoreInfo: ['Please provide more information about your event', '请提供更多有关您的活动的信息'],
  eventMoreInfoInstruction: [
    'You can put event description, rules, sponsors, and judges information here, It will be shown on your event detail page. You can change them later in event dashboard.',
    '活动描述，规则，赞助商，裁判等等, 创建赛事后您可以在赛事管理页面中继续更改。'
  ],
  eventBtnOnline: ['Online', '线上'],
  eventBtnOffline: ['Offline', '线下'],
  eventBtnHybrid: ['Hybrid', '混合'],
  eventBtnFree: ['Free', '免费'],
  eventBtnTicket: ['Ticket', '门票'],
  eventBtnPublic: ['Public', '公开'],
  eventBtnPrivate: ['Private', '私人'],
  eventBtnYes: ['Yes', '是'],
  eventBtnNo: ['No', '否'],
  eventBtnNext: ['Next', '下一步'],
  eventBtnBack: ['Back', '上一步'],
  eventDesign: ['Design your event', '设计你的活动'],
  eventDesignInstruction: ['You can always change the event design later in event dashboard', '活动设计可随时在设置里更改'],
  eventImageTemplateInstruction: ['Or select from the following templates', '或在以下模版中选择'],
  eventLocationPlaceholder: ['Search for a location', '输入一个地址以搜索'],
  eventPreview: ['Preview of your event', '你的活动的预览'],
  eventPreviewDetail: ['Event detail page', '活动详情页面'],
  eventPreviewListing: ['Event listing on HackHub homepage', '活动列出在黑咖主页的样式'],
  eventDescription: ['Description', '描述'],
  eventRules: ['Rules', '规则'],
  eventDetailTitle: ['Title', '标题'],
  eventIntro: ['Introduction', '赛事简介'],
  eventIntroContent: [
    'Describe what will happen at the event and what is interesting about it.',
    '您的赛事内容。'
  ],
  eventEligibility: ['Eligibility', '参赛人群'],
  eventEligibilityContent: ['Describe who can participate.', '参赛者合适人群。'],
  eventSubRequirement: ['Submission Requirement', '作品要求'],
  eventSubRequirementContent: ['Describe what to build and what to submit.', '参赛者上传作品要求。'],
  eventSponsors: ['Event Sponsors', '赛事赞助'],
  eventSponsorsContent: ['Upload the logos of sponsors here.', '上传赛事赞助图片。'],
  eventDetailContent: ['Content', '内容'],


  'Schedule Demo Title': ['Request to Host a Hackathon on HackHub', '申请使用HackHub管理您的创客松'],
  'Schedule Demo Subtitle': ['We will get in touch with you ASAP', '我们会尽快联系您'],
  Features: ['Features', '功能'],
  'First Name': ['First Name', '名字'],
  'Get Ticket': ['Get Ticket', '获取门票'],
  gitHubLink: ['GitHub Link', 'GitHub链接'],
  'Graduation Year': ['Graduation Year', '毕业年份'],
  help: ['Help', '求助'],
  'I agree to': ['I agree to', '我同意'],
  'In Progress': ['In Progress', '进行中'],
  'Invitation Required': ['Invitation Required', '需要邀请'],
  'Invite a Member': ['Invite a Member', '邀请小伙伴'],
  Jobs: ['Jobs', '招聘'],
  'Join Now': ['Join Now', '马上参加'],
  'Apply To Join': ['Apply To Join', '报名参赛'],
  ticketPaymentProcessing: ['Payment Processing', '处理支付中'],
  'Join This Event': ['Join this event', '马上参加'],
  'Need Invitation': ['Need Invitation', '需要邀请'],
  applicationClose: ['Application Close', '申请已关闭'],
  'Event Applied': ['Applied', '已申请'],
  Join: ['Join', '参加'],
  'Judges will Score the Projects': ['Engage with Mentors', '与大牛一起进步'],
  'Judging Criteria': ['Judging Criteria', '评审准则'],
  judging: ['Judging', '评审'],
  CountDown: ['Count Down', '倒计时'],
  'Last Name': ['Last Name', '姓氏'],
  'Latest Submission': ['Latest Submission', '最新上传作品'],
  // 'Let's Get Started': ['Let's Make Things Happen', '慧聚千里英才'],
  Location: ['Location', '地点'],
  LookingForJob: ['Looking for job', '正在求职'],
  'Mark as Read': ['Mark as Read', '标记为已读'],
  'Matching Score': ['Matching Score', '匹配度'],
  Members: ['Members', '队员'],
  'My Team': ['My Team', '我的团队'],
  teamSubmission: ['Team Submission', '团队作品'],
  'My Tickets': ['My Tickets', '我的门票'],
  'New Password': ['New Password', '新密码'],
  'No message': ['No message', '暂无消息'],
  'No tab selected': ['No tab selected', '没有被选择的区域'],
  'No, keep me in the team.': ['No, keep me in the team.', '哎呀，我点错了。'],
  'Not Now': ['Not Now', '不是现在'],
  Notifications: ['Notifications', '通知'],
  'Participate in Lively Hackathons': ['Meet New People and Form Teams', '结实合作伙伴'],
  Password: ['Password', '密码'],
  'Pending Members': ['Pending Members', '待审核成员'],
  'Phone Number': ['Phone Number', '电话号码'],
  'Please briefly explain your submission to help the host to understand your awesome work better.': [
    'Please briefly explain your submission to help the host to understand your awesome work better.',
    '请简略介绍一下让裁判对您的团队更加了解。'
  ],
  'Please submit at least one of the following. A Video link, a GitHub link or a zip file!': [
    'Please submit one of YouTube Video, GitHub or Zip',
    '请至少上传以下一项：介绍视频连接、开源GitHub链接 或者 上传一个zip文件。'
  ],
  'Please upload a zip file with all project files included.': [
    'Please upload a zip file with all project files included.',
    '请上传一个zip压缩文件'
  ],
  'Please verify your email': ['Please verify your email', '请验证您的邮箱'],
  projectThumbnail: ['Project Thumbnail*', '作品缩略图*'],
  Remove: ['Remove', '删除'],
  'Required Skills': ['Required Skills', '需要技能'],
  Requirements: ['Requirements', '工作要求'],
  'Reset Password': ['Reset Password', '重置密码'],
  Responsibilities: ['Responsibilities', '工作职责'],
  'Sign up to join': ['Sign up to join', '参加比赛'],
  'Log in to join': ['Log in to join', '登录参加比赛'],
  'Skills Needed': ['Skills Needed', '技能需求'],
  'Slack Integration': ['Slack Mentor System', '导师系统'],
  'Social media': ['Social media', '社交媒体'],
  'Submission Deadline': ['Submission Deadline', '作品递交截止时间'],
  submitMyProject: ['Submit My Project', '提交作品'],
  'Submit Now': ['Submit Now', '现在递交'],
  'Submit Your Amazing Projects': ['Bring Your Ideas to Life', '将创意变成作品'],
  'Submit Your Project': ['Submit Your Project', '递交你的作品'],
  Submit: ['Submit', '提交'],
  'Submitted at': ['Submitted at', '递交时间'],
  'Subscribe to newsletter': ['Subscribe to Newsletter', '订阅邮件'],
  'Succeussfully Update Project': ['Succeussfully Update Project', '更新成功'],
  'Team Name Required': ['Team Name*', '团队名称*'],
  'Team Name': ['Team Name', '团队名字'],
  'Team Group': ['Team Group', '团队分组'],
  'Team Creator': ['Team Creator', '团队创建者'],
  'Team Size': ['Team Size', '团队人数'],
  'Team Size Required': ['Team Size*', '人数上限*'],
  'Submission Github Not Public': ['Please contact team member to set their github repo public', '请联系成员公开github作品'],
  Teams: ['Teams', '团队'],
  'The preferred image size is 960px x 720 px. File sizes should be no bigger than 1 MB.': [
    'The preferred image size is 960px x 720 px. File sizes should be no bigger than 1 MB.',
    '图片优化尺寸为960像素x720像素。文件大小上限为1MB。'
  ],
  'This is a private submission': ['This is a private submission', '我们不会公开你的作品'],
  'Update My Team': ['Update My Team', '更新团队资料'],
  'Updating judging criteria will reset all scores, are you sure to proceed?': [
    'Updating judging criteria will reset all scores, are you sure to proceed?',
    '更新评判标准将重置所有分数，你还确定继续吗？'
  ],
  uploadThumbnail: ['Upload Thumbnail', '上传背景图'],
  'Upload Your File': ['Upload Your File', '上传文件'],
  videoLink: ['Video Link', '视频链接'],
  'View My Team': ['Team & Submission', '团队与提交作品'],
  'View Profile': ['View Profile', '个人资料'],
  'Email User': ['Email Contact', '邮件联系'],
  websiteLink: ['Website Link', '网站链接'],
  Website: ['Website', '网站'],
  'Welcome Join Event': ["Welcome! You've joined", '欢迎你加入'],
  'Win Awards': ['Win Prizes and Gain Experience', '赢取奖金，丰富经验'],
  'Yearly Salary': ['Yearly Salary', '年薪'],
  'Yes, I want to leave.': ['Yes, I want to leave.', '是的，我想暂时离开。'],
  'You are a judge': ['You are a judge', '您是评审'],
  'You have participated this project': ["You've participated this project.", '你已经参加了这个活动'],
  'Your latest submission will be considered as the final version.': [
    'Your latest submission will be considered as the final version.',
    '裁判只会看最后提交的作品'
  ],
  'Zip.file': ['Zip File', 'Zip压缩文件'],
  add: ['Add', '添加'],
  'admin.panel': ['Admin Panel', '管理界面'],
  'all.jobs': ['All jobs', '所有工作'],
  'and.upload': [' and upload to import participants', ' 并且填写好资料来上传导入数据'],
  importCSVFile: ['Import CSV File', '导入CSV文件'],
  apply: ['Apply Now', '申请'],
  attendees: ['Attendees', '人员'],
  accounts: ['Accounts', '账户'],
  screening: ['Screening', '筛选'],
  screeningAttendees: ['Screening Attendees', '筛选中的参赛人员'],
  rejectedAttendees: ['Rejected Attendees', '未通过的申请人员'],
  screeningEmailTemplate: ['Screening Email Template', '筛选邮件设定'],
  'screening.info': ['Allow to screen fields of application form and attendees', '允许筛选申请表内容和参赛人员'],
  'available.for.hiring': ['Available for hiring?', '想找工作吗？'],
  'award.name.required': ['Award Name *', '奖项*'],
  'topic.name.required': ['Theme Name *', '主题*'],
  'coupon.required': ['Coupon Code *', '优惠码*'],
  'question.required': ['Question *', '问题*'],
  awards: ['Awards', '奖项'],
  topics: ['Themes', '主题'],
  applicationForm: ['Application Form', '申请表'],
  'applicationForm.title': ['application form', '申请表'],
  back: ['Back', '返回'],
  skipForNow: ['I will do this later', '跳过'],
  'back.to.homepage': ['Back to Homepage?', '返回首页？'],
  billings: ['Billings', '账单'],
  hackhubAPI: ['Hackhub API', '黑咖创客 程序接口'],
  features: ['Features', '功能'],
  toolsBox: ['Tools Box', '工具箱'],
  banner: ['Banner', '置顶横幅'],
  cancel: ['Cancel', '取消'],
  'category options': ['Category filter...', '分类'],
  category: ['Category', '分类'],
  city: ['City', '城市'],
  closed: ['Closed', '不公开'],
  'company options': ['Company filter...', '公司'],
  company: ['Company', '公司'],
  'cover.image': ['Cover image for event listing', '封面图片'],
  'cover.image.instruction': ['Please upload an image with Gif, JPG or PNG format and the best aspect ratio is 16:9.', '请上传一张Gif, JPG或PNG格式的图片，16:9比例最佳'],
  'banner.image': ['Banner image for your homepage', '首页横幅图片'],
  'banner.image.instruction': ['Please upload an image with Gif, JPG or PNG format and the best aspect ratio is 37:9.', '请上传一张Gif, JPG或PNG格式的图片，37:9比例最佳'],
  'create job posting': ['Create Job Posting', '发布工作'],
  create: ['Create', '创建'],
  'create.new.form': ['Create New Form', '创建注册表格'],
  customUrl: ['Let\'s reserve a HackHub URL for your event, what is your event slug?', '自定义网址'],
  customUrlInstruction: ['Slug shouldn\'t contain any space and it cannot be changed later. Come up with a unique one!', '自定义网址在活动创建后不能修改'],
  externalSignupUrl: ['Event Homepage Url', '活动网站地址'],
  http: ['Do not forget http:// or https://', '别忘记填写http:// 或 https://'],
  dashboard: ['Dashboard', '控制界面'],
  eventAddMultiRound: ['Need extra round?', '添加多轮'],
  eventAddMultiRoundInstruction: ['You can setup submission deadline, themes, judging criteria, etc. for extra round in manage event page once this event is created. You can add up to three rounds', '您可以在管理活动页面设置多轮选项。您最多可以添加3轮。'],
  clientsFilterSubmissions: {
    filterText: ['Filter: ', '筛选: '],
    allThemes: ['All Themes', '所有主题'],
    allRounds: ['All Rounds', '所有轮次'],
    allGroups: ['All Groups', '所有群聊'],
    selectTheme: ['Select Theme', '选择主题'],
    selectRound: ['Select Round', '选择轮次'],
    selectGroup: ['Select Group', '选择群聊']
  },
  teamDetailCard: {
    deadlineInfo: {
      infoPrefix: ['Round ', ' 第 '],
      infoSuffix: [' Deadline', ' 轮上传截止时间'],
      singleRoundInfo: ['Submission Deadline', '上传截止时间']
    },
    header: {
      team: ['Team', '团队信息'],
      submission: ['Submission', '提交作品']
    },
    submitProject: {
      header: ['New Submission', '上传新作品']
    },
    dismissTeam: ['Dismiss Team', '解散团队']
  },
  submissionDetailCard: {
    forRoundNumber: ['Round ', '轮次 '],
    otherRoundSubmission: ['OTHER ROUNDS SUBMISSION', '其他轮次作品'],
    currentRoundSubmission: ['CURRENT ROUND SUBMISSION', '当前轮次作品']
  },
  newSubmission: {
    step: {
      describe: ['Describe Your Project', '描述您的作品'],
      upload: ['Upload the Deliverables', '上传您的作品'],
      themesAwards: ['Select Theme(s) and Award(s)', '选择作品的主题和参与的奖项']
    },
    themesAward: {
      selectThemes: ['Select Theme(s)', '选择主题'],
      selectAwards: ['Select Award(s)', '选择奖项']
    },
    backToMyTeam: ['My Team', '我的团队']
  },
  eventAdmin: {
    adminNav: {
      currentRound: ['Current Round: ', '当前轮次：'],
      roundPrefix: ['Round ', '第'],
      roundSuffix: ['  ', '轮']
    },
    eventLiveStreaming: ['Channel', '频道'],
    eventMonitor: ['Event Monitor', '赛事追踪'],
    eventTimeline: ['Event Timeline', '赛事时间线'],
    eventTimeLineSteps: {
      eventSetup: ['Event Set Up', '设置赛事'],
      eventStarts: ['Event Starts', '赛事开始'],
      submissionDeadline: ['Submission Deadline', '提交截止'],
      deadline: ['Deadline', '截止日期'],
      multiRoundSubDeadlineSuffix: [' Round Submission Deadline', '轮提交截止'],
      eventEnds: ['Event Ends', '赛事结束']
    },
    eventWebsite: {
      header: ['Event Website', '赛事网站'],
      view: ['View', '浏览页面'],
      url: ['Event URL', '网站链接'],
      eventPublicHeader: ['Public on HackHub Event', '在HackHub平台公开赛事'],
      eventPublicHeaderHelpText: ['Your event will be listed and searchable once it is public.', '您的赛事会被显示在首页的赛事列表中。'],
      updateEventPrivateStatusPrefix: ['Go to ', '您可以在 '],
      updateEventPrivateStatusSuffix: [' to change status.', ' 中改变活动公开状态。'],
      eventDetails: ['Event Details -> Event Settings', '活动详情 -> 活动设置']
    },
    ticketStatus: {
      header: ['Remaining Ticket', '剩余赛事门票'],
      edit: ['Edit Tickets', '编辑门票'],
      remaining: ['Remaining', '剩余']
    },
    applicationPreview: {
      header: ['Participants Application Form Preview', '参赛者申请表格预览'],
      edit: ['Edit Application Form', '编辑申请表'],
      currentStatus: ['Current status: ', '当前状态: '],
      openStatus: ['Open', '开放'],
      closeStatus: ['Close', '关闭'],
      notCreatedStatus: ['Form was not created, please contact tech support.', '申请表未被创建，请联系技术支持。']
    },
    coupon: {
      type: {
        percentage: ['Percentage', '折扣'],
        cash: ['Cash Equivalents', '代金券']
      }
    },
    judgingCriteria: {
      roundsSelectNav: ['Round', '轮次'],
      navDeadlineRange: ['Submission Period: ', '轮次时间段: ']
    },
    todoCheckList: {
      completed: ['completed', '已完成'],
      header: {
        beforeEventStart: ['Event Set Up Checklist', '赛事设置待办事项列表'],
        beforeFirstSubmissionDeadline: ['Submission Deadline 1 Checklist', '第1轮待办事项列表'],
        beforeSubmissionDeadlinePrefix: ['Submission Deadline', '第'],
        beforeSubmissionDeadlineSuffix: ['Checklist', '轮待办事项列表'],
        afterSubmissionDeadline: ['Event Ends Checklist', '赛事结束待办事项列表']
      },
      subHeader: ['Follow the to-do checklist to get started', '根据列表完成待办事项'],
      beforeEventStart: {
        title: ['Event Set Up Checklist', '赛事设置待办事项列表'],
        list: {
          fillBasicInfo: ['Fill in the basic information of the event', '填写赛事基本信息'],
          fillEventDetail: ['Fill in event details, judging criteria, themes and awards', '填写主题，奖项与评审规则'],
          setupApplication: ['Open application form for the event', '开启赛事申请表'],
          setupTickets: ['Set up the event tickets', '设置赛事门票'],
          screenNewApplication: ['Screen the new applications', '筛选新参赛者申请'],
          publishEvent: ['Publish your event', '公开您的活动']
        }
      },
      beforeSubmissionDeadline: {
        title: ['Submission Deadline ', '待办事项列表'],
        list: {
          selectTeamsForNextRound: ['Select advanced teams to next round', '筛选团队至下一轮'],
          multiRoundGiveAward: ['Give awards to the winners of this round', '现轮次颁发奖项'],
          reassignJudgesNTeam: ['Re-assign the judges and teams into groups', '重新分配评委至团队']
        }
      },
      beforeFirstSubmissionDeadline: {
        title: ['Submission Deadline 1 Checklist', '第一轮待办事项列表'],
        list: {
          assignJusgesNTeams: ['Assgin the judges and teams into groups', '分配评委至团队']
        }
      },
      afterSubmissionDeadline: {
        title: ['Event Ends Checklist', '赛事结束待办事项列表'],
        list: {
          giveAwards: ['Give awards to the winners of this round', '现轮次颁发奖项']
        }
      }
    },
    analysis: ['Analysis', '数据分析'],
    setupEvent: ['Set Up Event', '创建赛事'],
    eventDetails: ['Edit Event', '编辑比赛'],
    mentors: ['Mentors', '导师'],
    themesAndAwards: ['Themes and Awards', '主题与奖项'],
    eventWebsiteTemplate: ['Event Website Template', '赛事页面模板'],
    attendees: ['Attendees', '人员管理'],
    eventUpdates: ['Event Updates', '赛事资讯'],
    teamNSubmissions: ['Teams & Submissions', '团队和项目'],
    submissions: ['Submissions', '提交作品/项目'],
    application: ['Applications', '入场申请'],
    eventSocialMedia: ['Social Media Post ', '社交信息发布'],
    ticketing: ['Ticketing', '售票管理'],
    managers: ['Managers', '管理人员'],
    deleteTheEvent: ['Delete the Event', '删除活动'],
    eventDetailNav: {
      basicInfo: ['Basic Information', '基本信息'],
      overviewPage: ['Event Detail', '比赛详情'],
      eventSettings: ['Event Settings', '活动设置']
    },
    storage: {
      storageUsage: ['Storage Usage', '存储使用'],
      uploadsList: ['Uploads List', '上传列表'],
      fileType: ['File type', '文件类型'],
      fileSize: ['File size (byte)', '文件大小 (byte)'],
      uploaderEmail: ['Uploader Email', '上传者邮箱'],
      uploaderUsername: ['Uploader Username', '上传者用户名'],
      uploadTime: ['Upload Time', '上传时间']
    },
    eventPublicDisplay: ['This is currently a public event.', '此赛事目前状态为公开'],
    eventPrivateDisplay: ['This is currently a private event.', '此赛事目前状态为公开'],
    eventDetailEdit: {
      on: ['On', '是'],
      off: ['Off', '否'],
      public: ['Public', '公开'],
      private: ['Private', '私人'],
      publicStatus: ['Public Status', '公开状态'],
      eventType: ['Event Type', '活动类型'],
      eventName: ['Event Name *', '活动名称 *'],
      location: ['Location *', '地点 *'],
      timeZone: ['Time Zone *', '时区 *'],
      startTime: ['Start Date and Time *', '活动开始时间 *'],
      endTime: ['End Date and Time *', '活动结束时间 *'],
      competitionRounds: ['Competition Round(s) *', '赛事轮数 *'],
      selectRoundsPlaceHolder: ['Select the number of rounds', '选择赛事轮数'],
      selectPayoutAccRegion: ['Select payout account region and currency', '选择支付账号地区及货币'],
      submissionDeadline: ['Submission Deadline *', '提交截止时间 *'],
      applicationStartTime: ['Application intake time *', '参赛申请开始时间 *'],
      applicationStartTimePlaceholder: ['Select the application start time', '选择赛事申请开始时间'],
      applicationEndTime: ['Application Deadline *', '参赛申请结束时间 *'],
      applicationEndTimePlaceholder: ['Select the application end time', '选择赛事申请结束时间'],
      maxTeamSize: ['Max Team Size *', '团队人数上限 *'],
      tags: ['Tags *', '赛事标签 *'],
      bannerForEventDetail: {
        desc: ['Banner image for your homepage', '赛事详情横幅图片'],
        format: ['GIF, JPG, PNG / Ratio 37:9', 'GIF, JPG, PNG / Ratio 37:9']
      },
      coverForEventList: {
        desc: ['Cover image for event listing', '赛事列表封面图片'],
        format: ['GIF, JPG, PNG / Ratio 16:9', 'GIF, JPG, PNG / Ratio 16:9']
      },
      themes: ['Themes *', '赛事主题']
    },
    teams: {
      promoteTeamsModal: {
        title: ['Promote teams into next round', '选择晋级团队'],
        submitter: ['Submitter', '作品提交人'],
        score: ['Score', '得分']
      },
      promoteTeams: ['Promote teams into next round', '选择晋级团队']
    },
    settings: {
      tools: {
        luckyDraw: [`
        This tool is used for lucky-draw. Click the icon and start. It
        will help you pick random participants who is already checkd in.
        `, '帮助您随机选中一名已签到的参赛者，点击图像进入。'],
        countDown: [`
        This tool is used for count down. Click the icon and start. Show
        the count down page to attendees.
        `, '在赛事主页中显示赛事开始倒计时，点击图像启用。'],
        qrCodeCheckIn: [`
        Download the QR code image for wechat
        `, '下载二维码'],
        qrCodeImg: [`
        QRCode
        `, '二维码']
      }
    },
    manageEvents: {
      cardsDropdown: {
        editEvent: ['Edit Event', '编辑赛事'],
        viewPage: ['View the Event Page', '查看赛事页面'],
        cloneEvent: ['Clone Event', '复制赛事'],
        deleteEvent: ['Delete Event', '删除赛事']
      }
    },
    cloneEvent: {
      header: ['Copy Event', '复制赛事'],
      slugCheck: {
        contentPrefix: [
          'To copy the event ',
          '完成复制赛事 '],
        contentSurffix: [
          ', you need to enter a new event slug to reserve an URL for this event.',
          ', 您需要一个新的活动网址。'
        ],
        helpText: [
          'The slug must not contain any space. And it cannot be changed later.',
          '网址中不能包含特殊字符和空格，您不能在创建赛事后更改网址。'
        ]
      }
    },
    tourGuide: {
      next: ['Next', '下一步'],
      finish: ['Finish', '完成'],
      trackProgress: {
        title: ['Track your event progress', '您的赛事进度'],
        desc: [
          `Starting from the phase of “Event Set Up”, you’ve seen 
          a timeline showing your current and upcoming phases, 
          which enable you to track the progress easily.`,
          '赛事追踪中的时间线能够帮助您了解赛事的进度。']
      },
      checklist: {
        title: ['Get started with the checklist', '您的待办列表'],
        desc: [
          `Every phase has a to-do checklist which navigates you to the tasks directly. 
          Check if tasks are finished before you are moving to the next phase.`,
          '赛事的每个阶段都有独立的待办列表，完成代办事项以进一步完善您的活动。']
      },
      setupEvent: {
        title: ['Continue set up event', '您的赛事详情'],
        desc: ['Check out the tabs under Set Up Event, and continue to edit more details.',
          '您可以在这里设置赛事的详情，主题，奖项，评审规则，以及学习资源。']
      },
      publishEvent: {
        title: ['Publish event', '公开您的活动'],
        desc: ['Once you finished all the setting and editing, you are ready to publish your event.',
          '一旦您完成了所有设置与准备工作，请勿忘记公开您的活动。']
      }
    },
    participantsTourGuide: {
      addParticipants: {
        title: ['Add participant', '手动添加参赛者'],
        desc: ['To add new participants, you can enter serveral emails here simultaneously by using commas to separate different addresses.',
          '输入多个参赛者的电子邮箱，电子邮箱之间使用(英文输入法中的)逗号隔开']
      },
      importCSV: {
        title: ['Import CSV file', '导入参赛者csv文件'],
        desc: [
          `You can also download the template CSV file, fill it out by entering the emails in the sheet, 
          and then upload this file to add new participants.`,
          '您可以下载template csv文件，在文件中按照格式输入参赛者的电子邮箱再将编辑完成的文件上传。']
      },
      downloadParticipants: {
        title: ['Download all participant data', '下载参赛者数据'],
        desc: [`By clicking on this, 
          an excel sheet with all the participants' information will be automatically downloaded as an Office Excel spreadsheet.`,
        '参赛者数据会自动被整理成Excel形式文件。']
      }
    },
    teamsTourGuide: {
      assignGroup: {
        title: ['Assign teams to groups', '团队分组'],
        desc: [`To assign the teams to different judges, you can divide the teams into different groups. 
        A judge can judge one group or all groups.`,
        '给团队分组后，可以通过给评委分组达到评委评审指定团队的效果。一位评委可以评审一个组或所有组。']
      },
      promoteTeams: {
        title: ['Promote teams', '选择晋级团队'],
        desc: ['Once all judges finishing scoring, you are going to decide the teams to be promoted into next round by clicking this button.',
          '所有评委完成当前轮次的评审工作后，您可以点击按钮选择晋级团队。']
      }
    },
    applicationSettings: {
      selectTitle: ['select application language', '选择申请表单语言'],
      enApplication: ['English for .com user', '英语针对 .com 用户'],
      cnApplication: ['Chinese for .cn user', '中文针对 .cn 用户'],
      saveAndPreview: ['Save', '保存'],
      receivingApplication: ['Receiving Application', '已开始接收申请'],
      applicationClosed: ['Application Closed', '已停止接收申请']
    },
    payoutSetting: {
      setupDescription: [
        'You will need to set up your banking information to withdraw the ticket revenue.',
        '输入您的银行信息以获取赛事门票的收益。'
      ],
      bankAccountConstrain: [
        `By clicking on the button below, you will be guided to Stripe to set up your payout information. 
        Note that currently we only support the US and Canadian banks. For US bank accounts, we only support accounts in USD; For Canadian bank accounts, we only support accounts in CAD or USD. 
        If your bank account is outside of the regions mentioned above, or there is an error when setup your bank account in Stripe, please get in touch with info@hackhub.com`,
        `点击下方的按钮开始在Stripe平台设置您的银行信息。我们现在仅支持使用美国或加拿大的银行。
        如果您的账号属于美国银行，我们仅支持美元账号。如果您的账号属于加拿大银行，我们支持美元或加元账号。
        如果您的银行信息不符合上述条件或在Stripe平台设置银行信息时遇到错误，您可以联系技术支持info@hackhub.com。`
      ],
      stripeAccountDescription: [
        `Once you have set up the payout method, a Stripe account will be created for you. 
        You can change your linked bank account and view the balance once you log in to your Stripe account. 
        Stripe uses SMS code as a login method; the phone number should be the one you fill in when you set up your bank account.`,
        `在您完成设置银行信息后，Stripe会为您创建一个stripe账号。
        您可以在此stripe账号上更改您的银行信息，或查看stripe账号上的余额。
        stripe账号使用短信登录，短信会被发送到您在设置银行信息时填写的号码上。`
      ],
      payoutFlowDescription: [
        `Once you have set up the payout method, you can now create tickets for your event. 
        The revenue of each ticket sold will be sent to your Stripe account immediately once Stripe has authorized and authenticated the payment. 
        Stripe will automatically update your account's balance daily, and Stripe will transfer all the revenue to your bank account as long as it is not zero or negative. 
        The processing time of the payout depends on your bank and the region. On average, the payout takes around 4 business days to complete.`,
        `在设置完您的银行账号信息后，您可以开始设置赛事门票。
        Stripe完成每张门票的购买验证后，每张门票的收益会即刻出现在您的Stripe账号上。
        Stripe每天会检查您的Stripe账号，如果您的余额不为负数或零则将所有的数额转到您的银行账号上。
        上述的转账流程的时长会取决于您账号的所属银行及银行的所在地。一般情况下的转账时长为四个工作日左右。`
      ],
      setupButton: ['Set up Payout Method', '设置银行信息'],
      stripeAccountLogin: ['Your Stripe Dashboard', 'Stripe账号登录'],
      externalAccountsList: {
        title: ['Send payouts to account: ', '您的收益将会被转到以下账号: '],
        companyName: ['Company Name', '公司名：'],
        bankName: ['Bank Name', '银行名'],
        lastFour: ['Last 4 digits', '尾四位数字'],
        currency: ['Currency', '货币'],
        type: {
          bankAcc: ['Bank Account', '银行账号'],
          card: ['Card', '银行卡']
        }
      },
      preparationSetupPayout: [
        `NOTE: Please have your account's routing number, account number, company name(unnecessary if you are individually hosting this event),
        business address, business tax IDs, etc. ready before you start setting up your payout method. Only event creator is able to add payout method.`,
        '注意事项：在您开始添加您的银行信息前请准备好您账号的汇款路线号码，账号号码，公司名称，地址等信息。仅有赛事创建者拥有添加银行信息的权限。'
      ]
    },
    ticketingManagment: {
      menu: {
        ticket: ['Ticket', '赛事门票'],
        coupon: ['Coupon', '优惠券'],
        tax: ['Tax', '税款']
      },
      minTicketFee: [
        'Service fee will be 6% plus $2.55 for the first ticket of the month and 6% plus $0.55 per rest of the tickets.',
        '每月首张门票的手续费为 6% 加$2.55，后续的门票收费为 6% 加$0.55。'
      ],
      couponForm: {
        couponName: ['Coupon Name *', '优惠券名 *'],
        couponCode: ['Coupon Code (Optional)', '兑换码 (选填)'],
        amountOff: ['Amount Off', '代金券数额'],
        discountOff: ['Discount Off', '折扣券数额'],
        selectTicket: ['Coupon can be used for tickets: ', '能使用此优惠券的门票：'],
        maxRedemptions: ['Max Redemptions *', '优惠券兑换次数 *']
      },
      couponList: {
        showMore: ['show more', '更多'],
        showLess: ['show less', '收起'],
        maxRedemptions: ['Amount', '优惠券数量'],
        validForTickets: ['Can be used for tickets: ', '能被使用的门票：'],
        timesRedeemed: ['Redeemed', '已使用次数'],
        expiredDate: ['Expired Date', '到期时间'],
        retrieve: ['Click to Retrieve', '点击获取'],
        copyPromotionCode: ['Copy redeem code', '复制兑换码']
      },
      taxSettings: {
        title: ['Tax Settings', '税款设置'],
        description: ['Apply tax to the tickets or they will be tax-exempt.', '您的门票是含税的还是免税的'],
        applyTax: ['Apply Tax', '含税'],
        taxExempt: ['Tax-exempt', '免税']
      },
      taxForm: {
        country: ['Country', '国家'],
        taxId: ['Tax ID *', '税务登记号码 *'],
        taxRate: ['Tax Rate (percentage)*', '税率 *'],
        taxName: ['Tax Name *', '税名 *'],
        inclusive: ['Tax Calculation *', '税款计算 *'],
        included: ['Inclusive of Tax.', '税款已包含在您设置的票价内。'],
        notIncluded: ['Exclusive of Tax.', '税款不包含在您设置的票价内']
      }
    },
    invoicesNRefund: {
      title: ['Invoices and refund', '订单与退款'],
      navTabs: {
        invoices: ['Invoices', '订单'],
        refund: ['Refund Settings', '退款设定']
      },
      invoices: {
        subtotal: ['Subtotal', '小计'],
        total: ['Total', '共计'],
        status: ['Status', '支付状态'],
        pending: ['Pending', '审核中'],
        paid: ['Paid', '已付款']
      },
      refundPolicy: {
        title: ['Refund Policy', '退款协议'],
        notifyParticipants: ['Tell the attendees if the tickets are refundable.', '提示参赛者门票是否可以退款。'],
        refundable: ['Refundable', '可退款'],
        noRefunds: ['No Refunds', '不可退款'],
        selectRefundDeadline: ['When can attendees have refunds? *', '退款截止时间 *']
      }
    }
  },
  createEvent: {
    hackhubEvent: ['HackHub Event', '黑咖赛事'],
    subTitle: ['ALL-IN-ONE HACKATHON AND MANAGEMENT SYSTEM', '多合一黑客马拉松管理平台'],
    form: {
      header: {
        basic: ['Create a new event - Basic info', '创建新活动 - 基本信息'],
        detail: ['Create a new event - More details', '创建新活动 - 详细信息'],
        page: ['Create a new event - Design event page', '创建新活动 - 页面信息'],
        preview: ['Create a new event - Preview your event ', '创建新活动 - 预览页面']
      },
      subHeader: {
        nameNLocation: ['Name & Location', '名称与地点'],
        dateNTime: ['Date & Time', '日期与时间'],
        themesNSettings: ['Themes & Settings', '主题与设置'],
        eventDetail: ['Event Detail', '赛事详情'],
        banner: ['Banner image for your homepage', '赛事主页横幅图'],
        cover: ['Cover image for event listing', '赛事列表背景图'],
        eventDetailPage: ['Event detail page', '赛事主页'],
        eventCardInList: ['Event card in list on HackHub homepage', '在黑咖首页的活动列表中的卡片']
      },
      fields: {
        multiRounds: ['How many competition rounds in the event?', '您的赛事需要多少轮次?']
      }
    },
    nextBtn: {
      basic: ['Next: More Details', '下一步: 详细信息'],
      detail: ['Next: Design Event Page', '下一步: 页面信息'],
      page: ['Next: Preview', '下一步: 预览页面']
    },
    backBtn: {
      detail: ['Back: Basic Info', '上一步: 基本信息'],
      page: ['Back: More Details', '上一步: 详细信息'],
      preview: ['Back: Design Event Page', '上一步: 页面信息']
    },
    quitModal: {
      title: ['Quit Creating Event', '退出创建赛事'],
      content: [`Changes you made so far will not be save. 
      Are you sure you want to quit creating event?`, '您所做的改动将无法保存, 您确定要退出吗?']
    }
  },
  date: ['Date', '日期'],
  'date.and.time': ['Date & Time', '时间'],
  delete: ['Delete', '删除'],
  description: ['Description', '描述'],
  'do.you.want.to.delete': ['Do you want to delete ', '您确定要删除'],
  'do.you.want.to.remove': ['Do you want to remove ', '您确定要删除'],
  'do.you.want.to.accept': ['Do you want to accept ', '您确定要同意'],
  'do.you.want.to.reject': ['Do you want to reject ', '您确定要拒绝'],
  'do.you.want.to.create': ['Do you want to create ', '您确定要创建'],
  'do.you.want.to.update': ['Do you want to update ', '您确定要更新'],
  'do.you.want.to.score': ['Do you want to submit your score ', '您确定要提交打分'],
  'do.you.want.to.open': ['Do you want to open ', '您确定要打开'],
  'do.you.want.to.start': ['Do you want to start ', '您确定要开始'],
  'do.you.want.to.close': ['Do you want to close ', '您确定要关闭'],
  done: ['Done', '完成'],
  'dont.have.an.account': ['Don’t have an account?', '还没有帐号？'],
  download: ['Download', '下载'],
  'download.judge.data': ['Download Judge Data', '下载评审信息'],
  'download.participant.data': ['Download Participant Data', '下载参赛者信息'],
  'download.mentor.data': ['Download Mentor Data', '下载导师信息'],
  'download.volunteer.data': ['Download Volunteer Data', '下载志愿者信息'],
  'download.ranking.csv': ['Download Team Score', '下载作品分数'],
  'download.resume': ['Download Resume', '下载简历'],
  'download.submission': ['Download Submission', '下载作品'],
  'edit job posting': ['Edit Job Posting', '编辑工作'],
  'approved.Participant': ['Approved Participants', '批准参数者'],
  'approved.Judge': ['Approved Judges', '批准评审'],
  'approved.Mentor': ['Approved Mentors', '批准导师'],
  'approved.Volunteer': ['Approved Voluteers', '批准志愿者'],
  edit: ['Edit', '编辑'],
  'edit.award': ['Edit Award', '调整奖项'],
  'edit.topic': ['Edit Theme', '调整主题'],
  'edit.event': ['Event Details', '比赛详情'],
  'edit.template': ['Page Templates', '页面模版'],
  'edit.profile': ['Edit Profile', '修改资料'],
  'edit.social.media': ['Edit Social Media', '修改社交媒体'],
  'manage.event': ['Manage Event', '管理比赛'],
  email: ['Email', '邮箱'],
  'email.form.instruction': [
    'Please provide email(s), separate by comma. *',
    '请输入所有电子邮箱，并且以英文逗号（,）分开'
  ],
  end: ['End', '结束'],
  'end.date.and.time': ['End Date & Time', '结束时间'],
  ended: ['Ended', '已结束'],
  'enter.participant.email': ["Please enter the participant's email.", '请输入被邀请者的邮箱'],
  'event.content': ['Event Content', '比赛详情'],
  'event.description': ['Event Description', '活动简介'],
  'event.form': ['Event Form', '注册表格'],
  'event.information': ['Event Information', '活动详情'],
  'event.create.new.event': ['Create a new event - Basic info', '创建新活动 - 基本信息'],
  'event.name': ['What is your event name?', '您的比赛名称是什么？'],
  'event.page.headername': ['Events', '比赛活动'],
  'event.header.browse': ['Browse', '比赛活动'],
  'event.header.create': ['Create A New Event', ' 创建比赛'],
  'event.title': ['Event Title', '比赛名称'],
  'experience level': ['Experience Level', '工作经验'],
  'finish setup': ['Finish Setup', '完成创建'],
  'first.hackathon': ['Is this your first hackathon?', '这是您第一次参加黑咖吗？'],
  'forgot.password': ['Forgot Password?', '忘记密码？'],
  'forgot.password.reset': ['Reset Password', '重置密码'],
  'form.already.have.account': ['Already have an account?', '已有黑咖帐号？'],
  'form.confirmPassword': ['Confirm Password', '确认密码'],
  'form.get.started': ['Get Started', '开始'],
  'form.login': ['Login', '登录'],
  'form.password': ['Password', '密码'],
  'from.city': ['City you were from?', '城市'],
  'full name required': ['Full Name *', '姓名 *'],
  'github projects': ['GitHub Projects', 'GitHub 团队'],
  'github.link': ['GitHub Link', 'GitHub'],
  'give award': ['Give Award', '给予奖项'],
  'going.public': [
    'Private hackathons will not be seen by public and will be invite only',
    '私人黑客马拉松不会被公开，参与者只能通过邀请出席黑客松'
  ],
  'going.externalSignupUrl': [
    'If you want to use external event homepage website, attendees will signup application form from your website',
    '如果您想用第三方活动官方网站，参赛者将会从您的网站填写注册表'
  ],
  'externalSignupUrl.required': [
    'Please input whole event homepage url including http:// or https://.',
    '请填写完整的活动报名地址包括 http:// 或者 https://.'
  ],
  'hackhub projects': ['HackHub Projects', '黑咖创客团队'],
  'hear.from.us': ['Where did you hear about us?', '请问您是通过什么渠道了解我们?'],
  host: ['Captain', '队长'],
  'invite participants': ['Invite Participants', '邀请'],
  invite: ['Invite', '邀请'],
  invoices: ['Invoices', '订单'],
  invoicesNRefund: ['Invoices and refund', '订单与退款'],
  participantsRefundableDeadline: ['Can be refunded before ', '能在此日期前退款 '],
  ticketNotRefundable: ['Ticket is not refundable.', '门票无法被退款'],
  coupons: ['Coupons', '优惠券'],
  'is.public': ['Is Public?', '是否公开？'],
  'job.posting': ['Jobs', '招聘版'],
  judged: ['Judged', '已评分'],
  judges: ['Judges', '评审'],
  leave: ['Leave', '离开'],
  'lets set up your account': ["Let's Setup Your Account", '欢迎来到黑咖创客！'],
  limit: ['Limit *', '人数限制'],
  discountType: ['Discount Type', '优惠券类型'],
  discountAmount: ['Discount Amount', '优惠度'],
  quantity: ['Quantity', '数量'],
  'limit.of.prize': ['奖项数量', '奖项*'],
  'limit.of.prize.title': ['Quantity', '奖项'],
  'linkedin.link': ['LinkedIn Link', '领英'],
  'load more': ['Load more...', '读取更多...'],
  loading: ['Loading', '读取中'],
  location: ['Location', '地址'],
  'login.page.headername': ['Login Page', '登录页面'],
  major: ['Major', '专业'],
  'manage jobs': ['Manage jobs', '管理招聘'],
  mandatory: ['Mandatory', '必填项'],
  'mandatory.prize': ['Mandatory Prize', '必选奖项'],
  'mandatory.topic': ['Mandatory Theme', '必选主题'],
  'mandatory?': ['It is mandatory', '是否必填项？'],
  'max.tags.num': ['Max number of tags is ', '标签上限： '],
  'max.team.size': ['Max team size', '团队人数上限'],
  'maximum yearly salary': ['Maximum Annual Salary', '年薪上限'],
  maximumScore: ['Max Scores', '分数'],
  'minimum yearly salary': ['Minimum Annual Salary', '年薪下限'],
  minimum: ['Minimum', '最低分'],
  'my profile': ['My Profile', '个人资料'],
  'my tickets': ['My Tickets', '我的门票'],
  'user guide': ['User Guide', '用户手册'],
  'n.a': ['N/A', '不可用'],
  name: ['Name', '姓名'],
  'new.password.confirm.required': ['Confirm New Password*', '确认新密码*'],
  'new.password.required': ['New Password*', '新密码*'],
  no: ['No', '否'],
  'no.submission.data': ['No Submission Data', '暂无成员上传作品'],
  'not judged': ['Not Judged', '未评分'],
  'old.password.required': ['Old Password*', '旧密码*'],
  ordering: ['Ordering', '排序'],
  'ordering.explain': ['(the order of the prize display on the submission page) *', '(显示在递交页面的奖品排序)*'],
  overview: ['Overview', '概要'],
  participants: ['Participants', '参赛者'],
  organizers: ['Organizers', '举办方'],
  'personal.website': ['Personal website', '个人网站'],
  'please.download': ['Please Download ', '请下载  '],
  'please.fill': ['Please fill in application form fields first', '请先在申请表中填好选项'],
  'post.a.job': ['Post a job', '发布工作'],
  preview: ['Preview', '预览'],
  profile: ['Profile', '个人资料'],
  'project.description': ['Project Description', '团队介绍'],
  public: ['Public', '公开'],
  'public.reg.link': ['Public registration link: ', '链接: '],
  published: ['Published', '已发布'],
  ranking: ['Submissions', '项目作品'],
  'registration.form': ['Registration Form', '注册表格'],
  'reject.member': ['Reject', '拒绝'],
  remove: ['Remove', '删除'],
  'require.invitation': ['Does this event require invitation to join?', '参赛者是否需要邀请参加比赛？'],
  requirements: ['Requirements', '职位要求'],
  'reset.password': ['Reset Password', '重置密码'],
  responsibilities: ['Responsibilities', '工作责任范围'],
  resume: ['Resume', '简历'],
  'resume.analysis': ['Resume Analysis', '简历分析'],
  salary: ['Salary', '年薪'],
  save: ['Save', '保存'],
  school: ['School', '学校'],
  score: ['Score', '分数'],
  'search job title': ['Search job title...', '搜索岗位...'],
  'search location': ['Search location...', '搜索地址...'],
  search: ['Search', '搜索'],
  'seeking for new opportunities': ['Seeking for new opportunities!', '正在寻找新的就业机会'],
  'select category': ['Select Category', '选择分类'],
  'select company': ['Select Company', '选择公司'],
  'select end date': ['Select the start date and time', '选择结束日期'],
  'select event end date': ['Select the event start date and time', '选择活动结束日期'],
  'select event start date': ['Select the event start date and time', '选择活动开始日期'],
  selectEventSubDeadline: ['Select the event submission deadline', '选择活动提交截止日期'],
  'select exp lvl': ['Select Experience Level', '选择工作经验'],
  'select start date': ['Select the start date and time', '选择开始日期'],
  selectTemplate: ['Choose your template', '选择你的页面模版'],
  'showcase.your.social.media': ['Showcase Your Social Media', '展示社交媒体'],
  'sidebar.edit': ['Edit', '编辑'],
  'sidebar.email': ['Email', '邮箱'],
  'sidebar.events': ['Events', '活动页面'],
  'sidebar.location': ['Location', '地理位置'],
  'sidebar.phone.number': ['Phone Number', '电话号码'],
  'sidebar.profile': ['Profile', '个人资料'],
  'sidebar.tags': ['Tags', '标签'],
  'single.email.form.instruction': ['Please provide an email', '请输入电子邮箱'],
  'site navbar manage events': ['Manage Events', '活动管理'],
  'site.navbar.login': ['Log In', '登入'],
  'site.navbar.logout': ['Log Out', '登出'],
  'site.navbar.signup': ['Sign Up', '注册'],
  start: ['Start', '开始'],
  'start.by.typing.emails': ['Start by typing emails...', '输入邮箱开始邀请'],
  'start.date.and.time': ['Start Date & Time', '开始时间'],
  status: ['Status', '状态'],
  submissions: ['Submissions', '作品'],
  submit: ['Submit', '递交'],
  submitted: ['Submitted', '已递交'],
  notSubmitted: ['Not Submit', '未递交'],
  'tags hint': ['Select ..', '例如： web [然后点击回车键]...'],
  team: ['Team', '团队'],
  searchingTeam: ['Searching teams...', '寻找团队中...'],
  'ticket.description': ['Description', '门票描述'],
  'ticket.name.required': ['Ticket Name *', '门票类型*'],
  'ticket.price.required': ['Price *', '门票价格*'],
  'ticket.quantities.required': ['Quantity *', '门票数量*'],
  tickets: ['Tickets', '门票'],
  payoutMethods: ['Payout Method', '转账方式'],
  timezone: ['Timezone', '时区'],
  title: ['Title', '标题'],
  'title.account': ['Account', '帐户'],
  'title.profile': ['Profile', '我的资料'],
  'title.required': ['Title *', '标题*'],
  'total average score': ['Total', '总分'],
  update: ['Update', '更新'],
  deleteAccount: ['Delete Account', '删除账号'],
  deleteAccountInfo: ['Are you sure to delete your account? <br/> If you delete your account, you will permanently lose your profile and files.', '您确定要删除账号吗？ 如果您删除了账号，您将永久失去个人信息和文件'],
  'update.password': ['Update Password', '更新密码'],
  'update.your.profile': ['Update your profile', '更新您的个人资料'],
  'upload resume successfully': ['Upload Resume Successfully', '上传简历成功'],
  uploadResume: ['Upload Resume', '上传简历'],
  'upload.file': ['Upload File', '上传文件'],
  'upload.form.background': ['Upload form background', '上传背景'],
  'upload.logo': ['Upload Logo', '上传logo'],
  'upload.resume': ['Upload Resume', '上传简历'],
  'user name required': ['User Name *', '用户名 *'],
  'valid username explaination': [
    "A valid username can include letters, numbers and '_' only.",
    '用户名只能包含英文字母、数字或者下划线 _ .'
  ],
  'website.url': ['Website URL', '网站链接'],
  yes: ['Yes', '是'],
  'your event name': ['Your Event Name', '活动名称'],
  yourEventSlugWarning: ["You won't be able to customize the url later", '你将无法在稍后改变活动网址'],
  yourEventSlug: ['Your Event Slug', '活动网址'],
  yourResume: ['Your Resume', '您的简历'],
  yourTopSkills: ['Your Top ${num} Skills', '您的${ num }个技能'],
  yourEducation: ['Your Education Level', '您的教育水平'],
  yourProfession: ['Your Profession', '您的专业'],
  'team member detail': ['Team Member Detail', '团队成员细节'],
  'teams detail': ['Teams Detail', '队伍细节'],
  invoicesData: ['invoicesData', '订单数据'],
  'submission detail': ['Submission Detail', '作品细节汇总'],
  'submission name': ['Submission Name', '作品名称'],
  'view submission': ['View Last Submission', '查看已提交作品'],
  'load team rankings': ['Load Team Rankings', '评审结果汇总'],
  'criteria categorization': ['Categorized By Criteria', '按评审准则结果汇总'],
  'judge categorization': ['Categorized By judge', '按专家结果汇总'],
  rank: ['Ranking', '排名'],
  project: ['project', '作品'],
  projectName: ['Project Name', '作品名称'],
  'topic name': ['Theme Name', '主题名称'],
  'award name': ['Award Name', '获奖名称'],
  projectNameRequired: ['Project Name*', '作品名称*'],
  'judge bundle': ['Judge Bundle', '专家评审结果细节'],
  'global ranking': ['Global Ranking', '总表'],
  'judge ranking': ['Judge Ranking', '评委表'],
  group: ['Groups', '分组'],
  'group number': ['Group', '分组'],
  'select group': ['Select Group', '选择分组'],
  'sort by status': ['Sort by Status', '选择用户状态'],
  'select role': ['Select Role', '选择角色'],
  'select theme': ['Select Theme', '选择主题'],
  'team table': ['Team Table', '队伍桌子'],
  'my create event': ['My Created Event', '我创建的活动'],
  'my manage event': ['My Managed Event', '我管理的活动'],
  'my participate event': ['My Participanted Event', '我参加的活动'],
  'Enable Slack Integration': ['Enable Slack Integration', '开启Slack系统链接'],
  'Slack Notes': ['This integration can help you link your event to a private channel of your Slack. When this feature is enabled and properly configured, participants can send message to the linked Slacked channel after they start on a project.',
    '连接比赛到Slack的专用频道。 启用并正确配置此功能后，参与者可以向连接的Slack频道发送讯息。'],
  'Slack Webhook Link': ['Slack Webhook Link', 'Slack 网络链接'],
  Example: ['Example', '举例'],
  mandatoryField: ['Mandatory', '必选项'],
  type: [],
  'type.String': ['String', '格式：文字'],
  'type.Boolean': ['Boolean', '格式：是/否'],
  'type.Number': ['Number', '格式：数字'],
  true: ['True', '是'],
  false: ['False', '否'],
  'You are volunteer': ['You are volunteer', '您是志愿者'],
  application: {
    application: ['application', '申请'],
    'common.common': ['Common', '共用'],
    uid: ['User Id', '用户ID'],
    required: ['Required', '*必填'],
    chosen: ['Chosen', '已选'],
    fieldName: ['Field Name', '选项名称'],
    name: ['Name', '姓名'],
    email: ['Email', '邮箱'],
    phone: ['Phone', '电话'],
    hasWaiver: ['Has Waiver', '拥有代金劵'],
    photoConsent: ['Photo Consent', '给予肖像权'],
    notes: ['Notes', '备注'],
    isMinor: ['Minor', '未成年'],
    foodVoucher: ['Food Voucher', '食物代金劵'],
    questionType: ['User Answer Type', '用户回答类型'],
    eventSlug: ['Event Slug', '活动网址'],
    commonFields: {
      string: ['Text', '文字'],
      textArea: ['Long Text', '长文本'],
      number: ['Number', '数字'],
      boolean: ['Yes/No', '是/否'],
      file: ['File', '文件']
    },
    participant: {
      participant: ['Participant', '参与者'],
      street: ['Street', '街名'],
      city: ['City', '城市'],
      region: ['Region', '地区'],
      postalCode: ['Postal Code', '邮编'],
      country: ['Country', '国家'],
      companyName: ['Company', '公司'],
      college: ['College', '学校'],
      graduationYear: ['Graduation Year', '毕业时间'],
      eventAttended: ['Event Attended', '参加过的活动'],
      resumeUrl: ['Resume Url', '简历'],
      github: ['GitHub', 'GitHub'],
      linkedin: ['LinkedIn', 'LinkedIn'],
      isJobSeeking: ['Job Seeking', '求职'],
      accessibility: ['Accessibility', '伤残'],
      agreeMLH: ['Agree to MLH', '同意MLH条款'],
      agreeSharing: ['Agree With Sharing Code', '同意公开参赛代码'],
      tShirtSize: ['T-shirt Size', 'T恤尺码'],
      gender: ['Gender', '性别'],
      reimbursement: ['Reimbursement', '报销']
    },

    volunteer: {
      volunteer: ['Volunteer', '志愿者'],
      attendTraining: ['Attend Training', '参加培训'],
      attendRehearsal: ['Attend Rehearsal', '参加排演'],
      tShirtSize: ['T-shirt Size', 'T恤尺码'],
      linkedin: ['LinkedIn', 'LinkedIn'],
      college: ['College', '学校'],
      resumeUrl: ['Resume Url', '简历'],
      agreeMLH: ['Agree to MLH', '同意MLH条款'],
      admitted: ['Admitted Application', '曾提交申请']
    },

    mentor: {
      mentor: ['Mentor', '导师'],
      attendTraining: ['Attend Training', '参加培训'],
      tShirtSize: ['T-shirt Size', 'T恤尺码'],
      resumeUrl: ['Resume Url', '简历'],
      github: ['Github', 'Github'],
      linkedin: ['LinkedIn', 'LinkedIn'],
      street: ['Street', '街名'],
      city: ['City', '城市'],
      region: ['Region', '地区'],
      agreeMLH: ['Agree to MLH', '同意MLH条款'],
      admitted: ['Admitted Application', '曾提交申请']
    },

    judge: {
      judge: ['Judge', '评委'],
      profileUrl: ['Profile Url', '个人网站地址'],
      bio: ['Bio', '自我介绍'],
      tShirtSize: ['T-shirt Size', 'T恤尺码'],
      linkedin: ['LinkedIn', 'LinkedIn'],
      agreeMLH: ['Agree to MLH', '同意MLH条款'],
      admitted: ['Admitted Application', '曾提交申请']
    },
    startApplication: ['Start Application', '开始申请'],
    stopApplication: ['Stop Application', '停止申请'],
    clearAll: ['Clear All', '清除全部选项']
  },
  chat: {
    messages: ['Messages', '聊天'],
    contacts: ['CONTACTS', '联系人'],
    search: ['Search', '搜索'],
    groups: ['GROUPS', '群聊'],
    startTyping: ['Start typing here', '请在此处开始输入']
  },
  introductionVideo: ['Introduction video for events management', '活动管理的介绍视频'],
  pageNotFound: ['Page Not found, please check the url', '页面找不到, 请检查网址'],
  overDeadline: ['Can not submit after deadline', '在最后期限之后不能提交作品'],
  notUploadResume: ['You haven not uploaded any resume yet.', '您还没有提交简历'],
  notUploadResumeTip: ['Tip: Most of the hackathon organizers will screen your resume before accepting your application', '提示：大多数创客马拉松组织者在同意申请前会查看您的简历'],
  chooseTheme: ['Select Theme', '选择主题'],
  pleaseChooseTheme: ['Please select event themes', '请选择赛事主题'],
  eventRecommendation: ['Related Event Recommendation', '相关赛事推荐'],
  jdRecommendation: ['Related Jobs Recommendation', '相关工作推荐'],
  eventSocialMedia: ['Social Media Post ', '社交信息发布'],
  streamCover: ['LiveStream Cover Image', '直播封面'],
  addHost: ['Add Host *', '添加主讲人 *'],
  chooseTimeZone: ['Choose TimeZone', '选择时区'],
  startTime: ['Start Date & Time', '开始时间'],
  endTime: ['End Date & Time', '结束时间'],
  addTitle: ['Add Title *', '添加标题 *'],
  uploadVideo: ['Upload Video', '上传视频'],
  liveVideo: ['LiveStream Video', '直播视频'],
  liveUrl: ['LiveStream Url', '直播网址'],
  liveKey: ['LiveStream Key', '直播秘钥'],
  comingSoon: ['Coming Soon', '敬请期待'],
  livestreamEnd: ['Ended', '直播已结束'],
  duringLivestreaming: ['Livestreaming', '正在直播中'],
  LiveStreamPost: ['Channel Schedule', '频道时间表'],
  chatArea: ['Chat Room', '讨论区'],
  chatRoomComingSoon: ['Chatroom is coming soon', '评论区未开放,敬请期待'],
  generateLink: ['Generate Link', '生成链接'],
  recreateUrl: ['Hint:When you reset end time, please regenerate the livestreaming link to get new link and key', '温馨提醒：当更新结束的时间的时候，请重新点击生成链接来获取新的直播网址和秘钥'],
  relatedSocialMedia: ['Social posts', '社交资讯'],
  relatedPeople: ['People', '人员信息'],
  chooseSocialMediaAcc: ['Please choose your social media account', '请选择你的社交账号'],
  socialMediaAuth: ['Please choose related socialMedia platform and authorize Hackhub to access the information', '请选择相关社交平台，并授权给Hackhub Event权限以发布信息'],
  socialMediaAll: ['All', '全部'],
  socialMediaToday: ['Today', '今日'],
  socialMediaThisWeek: ['This Week', '本周'],
  socialMediaThisMonth: ['This Month', '本月'],
  socialMediaPosted: ['Publish', '已发布'],
  socialMediaUnposted: ['Unpublish', '未发布'],
  socialMediaChooseAll: ['Choose All', '全选'],
  socialMediaClearAll: ['Clear Choices', '撤销选择'],
  socialMediaUnpost: ['Unpublish', '取消发布'],
  socialMediaPost: ['Publish', '发布'],
  socialMediaDelete: ['Delete', '删除'],
  fbComingSoon: ['FaceBook login function is coming soon', 'Facebook 授权即将开放'],
  socialMediaEnterKeyWord: ['Please enter keyword', '输入关键字例如emaple'],
  socialChoose: ['Choose Social Media', '选择社交平台'],
  dateChoose: ['Choose Post Date', '选择发布日期'],
  statusChoose: ['Choose Post Status', '选择帖子状态'],
  socialMediaSort: ['SocialMedia Sort', '排序顺序'],
  socialMediaAccordSort: ['Sort by accord time', '时间从早到晚'],
  socialMediaReverseSort: ['Sort by reverse time', '时间从晚到早'],
  socialMediaCancel: ['Cancel', '取消'],
  socialMediaConfirm: ['Confirm', '确认添加'],
  socialMediaAdd: ['Add', '添加'],
  socialMediaEnterHashTag: ['Please enter the hashTag', '请输入hashtag'],
  confirmDeletePost: ['Confirm Deleting', '确认删除'],
  confirmDeletePostContent: ['Are you sure to delete selected posts?', '你是否确定删除选中帖子？'],
  confirmUnpublishPost: ['Confirm Unpublishing', '确认撤回发布'],
  confirmUnpublishPostContent: ['Are you sure to unpublish selected posts?', '你是否确认撤回发布选中的帖子'],
  confirmPublishPost: ['Confirm Publishing', '确认发布'],
  confirmPublishPostContent: ['Are you sure to publish selected posts?', '你是否确认发布选中的帖子'],
  chatManager: ['Manager', '管理人员'],
  chatMentor: ['Mentor', '导师'],
  chatPaticipant: ['Participant', '参赛人员'],
  chatSearch: ['Search', '搜索'],
  chatOnline: ['online', '在线'],
  chatOffline: ['offline', '离线'],
  chatProfile: ['Profile', '主页'],
  chatContact: ['Message', '联系他'],
  largeChatNoMessage: ['No Message Yet', '还没有聊天信息'],
  largeChatEnter: ['Please enter your message', '快快加入聊天吧'],
  openEventChannel: ['Event managers can open event channel', '管理员可以打开直播'],
  tagsEnterHint: ['Hint: Please press Add button after you enter the tags, and it has to be at lease one tags before you can confirm', '提示：请在填好每一个标签之后点添加按钮，必须有至少一个标签才可以确认提交'],
  mobileAgent: [
    'Please use web version to access.',
    '请使用电脑使用该功能'
  ],
  submissionComment: ['Comments for this submission...', '对该作品评价...'],
  SubmissionLikeError: ['Please login to like the submission', '请先登录再给作品点赞'],
  loginToJoin: ['Please log in to see the resource', '请先登录再查看该学习资源'],
  privateResource: ['Please join the event to see the private learning resource', '请先加入该比赛再查看私有学习资源'],
  resourcePublic: ['Public', '公开资源'],
  resourcePrivate: ['Private', '私有资源'],
  closeTeamChat: ['Close', '关闭'],
  openTeamChat: ['Idea Discuss', '讨论板'],
  projectIdea: ['Project Idea', '项目理念'],
  currentIdea: ['Current Idea', '当前理念'],
  noComment: ['No comments yet', '还没有评论'],
  latestSubmission: ['Latest Submission', '最新作品'],
  enterProjectIdea: ['Enter Project Idea', '输入项目理念'],
  viewPrivateSubmission: ['This submission is private', '该作品是私有的'],
  themeEngage: ['Theme Engagement', '主题参与度'],
  pageEngage: ['Event Engagement', '活动页面参与度'],
  ticketSales: ['Ticket Sales Overview', '门票销售概要'],
  attendeeDemographics: ['Demographics', '参赛者分布'],
  registrationOverview: ['Registration Overview', '注册概要'],
  totalApplicant: ['Total', '所有申请'],
  inScreening: ['In Screening', '筛选中'],
  teamOverview: ['Team Overview', '队伍概要'],
  organizedBy: ['Organized By', '组织者：'],
  seconds: ['s', '秒'],
  acceptPolicyMessage: ['We use first and third party cookies to enhance the site, collect and analyze access data, and to include features provided by Google, heap, and Stripe. If you continue browsing, we assume that you accept. For more information, please read the', '我们使用第一方和第三方 cookie 来完善网站、收集和分析访问数据，其中包含 Baidu Statistics, heap 和 Stripe 提供的功能。如果您继续浏览，我们默认您接受关于cookie使用的相关协议。如需更多信息，请阅读'],
  termsOfService: ['Terms of Service', '服务条款'],
  shortAcceptPolicyMessage: ['We use first and third party cookies to enhance the site', '我们使用第一方和第三方 cookie'],
  weeklyNewsLetter: ['Weekly Newsletter', '每周简报'],
  newsLetterMessage: ['Don’t miss out on new events! Subscribe to our newsletter to receive latest event news.', '不要错过我们的最新赛事！ 订阅我们的简报邮件获取最新资讯。'],
  inviteFriends: ['Invites Friends', '邀请好友'],
  otherEventsYouMayLike: ['Other Events You May Like', '猜你喜欢'],
  logInToCheckAndJoin: ['Login to check and join the teams', '登录查看并加入队伍'],
  relatedPositions: ['Related Positions', '相关职位']
};




// WEBPACK FOOTER //
// ./src/i18n/translations.js